import React, { useMemo } from "react"
import classNames from "classnames"
import type { ChangeEvent } from "react"

import "bootstrap-icons/font/bootstrap-icons.css"
import { useEffect, useRef, useState, useCallback } from "react"

import { Tab, Nav, Button, Row, Col, Form, Card, Modal } from "react-bootstrap"
import { InputGroup } from "react-bootstrap"
import Select from "react-select"
import DashboardContainer from "../../../components/common/DashboardContainer"
import { faChevronLeft, faChevronRight, faPencilAlt, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { matchPath, useLocation, useNavigate } from "react-router-dom"
import DataTable from "../../common/components/DataTable"
import {
  getapp,
  getTemplateInfobyID,
  getTemplateList,
  getTemplateParse,
  getTemplateParseByFieldName,
  readTemplate,
  templateDelete,
  updateTemplate,
  validateIdentifers,
} from "../../../template"
import { useDispatch } from "react-redux"
import type { AppDispatch } from "../../../../../../cpp-web-app/ui/src/app/store"
import { Divider } from "semantic-ui-react"
import { useSelector } from "react-redux"
import type { RootState } from "./store"
import { toast } from "react-toastify"
import ExtractorModal from "./extract-modal"
import UnsavedChangesModal from "../../../components/common/UnsavedChangesModal"

// Define interfaces for our data structures
interface ExtractionStrategy {
  extractorName: string
  parameters: string[]
}

interface TransformationStep {
  id: string
  operation: string
  parameters: string[]
}

interface TransformationStrategy {
  transformationSteps: TransformationStep[]
}

interface FilterCriterion {
  //id: string
  operand1: {
    value: string
    extractionStrategy: ExtractionStrategy | null
  }
  operator: string
  operand2: {
    value: string
    extractionStrategy: ExtractionStrategy | null
  }
}

interface FilterStrategy {
  filterCriteria: FilterCriterion[]
  select: string
}

interface FieldData {
  fieldName: string
  fixedValue: string
  filterStrategy: FilterCriterion[] | FilterStrategy
  extractionStrategy: ExtractionStrategy | null
  transformationStrategy: TransformationStrategy | null
}

interface TemplateInfo {
  fields: {
    fieldName: string
    fixedValue: string
    filterStrategy: FilterStrategy
    extractionStrategy: ExtractionStrategy | null
    transformationStrategy: TransformationStrategy | null
  }[]
}

const TemplateUploadScreen = () => {
  const dispatch = useDispatch<AppDispatch>();

  const templateStructure = useSelector((state: RootState) => state.templateSlice.templateStructure)
  const [transformationOperations, setTransformationOperations] = useState<any[]>([]);
  const [pdfParserAppData, setPdfParserAppData] = useState<any>(null);
  useEffect(() => {
    dispatch(getapp())
      .unwrap()
      .then((response: any) => {
        if (response.data && Array.isArray(response.data.operations)) {
          setTransformationOperations(response.data.operations.map((op: any) => ({ value: op.name, label: op.label })));
          setPdfParserAppData(response.data);
        }
      })
      .catch(() => {
        setTransformationOperations([]);
        setPdfParserAppData(null);
      });
  }, [dispatch]);

  // Helper to get parameters for a selected operation
  const getOperationParameters = (operationName: string) => {
    if (!pdfParserAppData || !Array.isArray(pdfParserAppData.operations)) return [];
    const op = pdfParserAppData.operations.find((o: any) => o.name === operationName);
    return op && Array.isArray(op.parameters) ? op.parameters : [];
  };

  // Helper to get parameters for a selected extractor
  const getExtractorParameters = (extractorName: string) => {
    if (!pdfParserAppData || !Array.isArray(pdfParserAppData.extractors)) return [];
    const extractor = pdfParserAppData.extractors.find((e: any) => e.name === extractorName);
    return extractor && Array.isArray(extractor.parameters) ? extractor.parameters : [];
  };

  const LINES_PER_PAGE = 30
const [characterToReplace, setCharacterToReplace] = useState('');
const [replaceWithCharacter, setReplaceWithCharacter] = useState('');


  const stepList = [
    { key: "info", label: "Info", icon: "bi-info-circle" },
    { key: "fields", label: "Fields", icon: "bi-list-task" },
    { key: "identification", label: "Identification", icon: "bi-fingerprint" },
    { key: "read", label: "Read", icon: "bi-eye" },
    { key: "json", label: "Json View", icon: "bi-code-slash" },
    { key: "test", label: "Test", icon: "bi-bug" },
  ]
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const fileInputIdentifier = useRef<HTMLInputElement | null>(null)
  const fileInputRefTest = useRef<HTMLInputElement | null>(null)
  const fileInputRefMain = useRef<HTMLInputElement | null>(null)
  
  const [parameterLabel, setParameterLabel] = useState("Parameter")
  const [extractorParameter, setExtractorParameter] = useState("")
  const [dataTypeOptions, setDataTypeOptions] = useState<any[]>([])
  const [showModal, setShowModal] = useState(false)
  const [showFormSlider, setShowFormSlider] = useState(false)
  const location = useLocation()
  const [newTemplate, setNewTemplate] = useState({
    name: "",
    schema: "payment-schema",
    format: "PDF",
  })
  const initialFilterState = {
    operand1: "",
    fixedValue1: "",
    parameter: "",
    operator: "",
    operand2: "",
    fixedValue2: "",
    index: "",
    dataType: "",
    operand2Extractor: "",
    operand2Parameter: "",
    operand2Value: "",
    operand2Index: "", // Add field for Operand 2 index
  };
  
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
   const handleStayOnPage = () => {
    console.log('UnsavedChangesModal: Stay on page');
    setShowUnsavedModal(false);
    setPendingCancel(null);
  };

  // Handler for leaving the page (confirm navigation)
  const handleLeavePage = () => {
    console.log('UnsavedChangesModal: Leave page, pendingCancel:', pendingCancel);
    setShowUnsavedModal(false);
    if (pendingCancel === 'filter') {
      setNewFilter(initialFilterState);
      setShowFilterSlider(false);
      
    } else if (pendingCancel === 'extractor') {
      setIsAddingExtract(false);
      setShowExtractorModal(false);
      setExtractorType("");
      setExtractorParameter("");
    } else if (pendingCancel === 'transform') {
      setIsAddingTransform(false);
      setShowTransformModal(false);
      setTransformRules([]);
    } else if (pendingCancel === 'json') {
      setIsJsonDirty(false);
      setFieldConfigTab('fixedValue');
      setJsonError(null); // Reset the error!
    }
    setPendingCancel(null);
  };
  const [pendingCancel, setPendingCancel] = useState<null | 'filter' | 'extractor' | 'transform' | 'json'>(null);
  const [jsonError, setJsonError] = useState<string | null>(null)
  const [showExtractorModal, setShowExtractorModal] = useState(false)
  const [isEditingTemplateName, setIsEditingTemplateName] = useState(false)
  const [editedTemplateName, setEditedTemplateName] = useState("")
  const [isEditingResponseTo, setIsEditingResponseTo] = useState(false)
  // Fields state
  const [fields, setFields] = useState<any>([])
  const [extractorType, setExtractorType] = useState("")
  const [selectedField, setSelectedField] = useState("")
  const [fieldConfigTab, setFieldConfigTab] = useState("")
  const [fixedValue, setFixedValue] = useState("")
  const [editedJsonText, setEditedJsonText] = useState("")
  const [templates, setTemplates] = useState<any[]>([])

  const templateOptions = React.useMemo(() => {
    if (!Array.isArray(templates)) return [] // ✅ avoid crash
    return templates.map((t: any) => ({
      value: t.value,
      label: t.text,
    }))
  }, [templates])

  const navigate = useNavigate()
  const [filterRules, setFilterRules] = useState<any[]>([])
  const [jsonString, setJsonString] = useState("")
  const [page, setPage] = useState(0)

  const lines = useMemo(() => jsonString.split("\n"), [jsonString])
  const totalPages = Math.ceil(lines.length / LINES_PER_PAGE)

  const currentPageLines = lines.slice(page * LINES_PER_PAGE, (page + 1) * LINES_PER_PAGE).join("\n")

  const [transformRules, setTransformRules] = useState<any[]>([])
  const [isAddingTransform, setIsAddingTransform] = useState(false)
  const [isAddingExtract, setIsAddingExtract] = useState(false)
  const [isAddingFilter, setIsAddingFilter] = useState(false)

  const [extractorRules, setExtractorRules] = useState<any[]>([])
  const [selectedFieldExtract, setSelectedFieldExtract] = useState<any>(null)
  const [selectedTemplate, setSelectedTemplate] = useState("")
  // Add a new state for the filter form slider
  const [showFilterSlider, setShowFilterSlider] = useState(false)
  const [newFilter, setNewFilter] = useState({
    operand1: "",
    fixedValue1: "",
    parameter: "",
    operator: "",
    operand2: "",
    fixedValue2: "",
    index: "",
    dataType: "",
    operand2Extractor: "",
    operand2Parameter: "",
    operand2Value: "",
    operand2Index: "", // Add field for Operand 2 index
  })

  // Add state for test tab
  const [testFile, setTestFile] = useState<File | null>(null)
  const [testResults, setTestResults] = useState<any>({})
  const [testResultsField, setTestResultsField] = useState<any[]>([])
  const [testReadResults, setTestReadResults] = useState<{ id: number; value: any }[]>([])

  const [isEditingEmail, setIsEditingEmail] = useState(false)
  const [isEditingIdentifier, setIsEditingIdentifier] = useState(false)
  interface TestResult {
    id: number
    value: any
  }
  const [currentPage, setCurrentPage] = useState(1)
  const rowsPerPage = 10

  const paginatedResults = testReadResults?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)

  const totalPagestestRead = Math.ceil((testReadResults?.length || 0) / rowsPerPage)

  const [testRecords, setTestRecords] = useState<number>(0)
  const [testRecordsField, setTestRecordsField] = useState<number>(0)
  const [testReadRecords, setTestReadRecords] = useState<number>(0) // Initialize as 0

  const [templateInfo, setTemplateInfo] = useState<any>({
    fields: [],
  })
  const ITEMS_PER_PAGE = 100

  const [testPage, setTestPage] = useState(0)

  const testTotalPages = Math.ceil((Array.isArray(testResultsField) ? testResultsField.length : 0) / ITEMS_PER_PAGE)

  const paginatedTestResults = Array.isArray(testResultsField) ? testResultsField.slice(testPage * ITEMS_PER_PAGE, (testPage + 1) * ITEMS_PER_PAGE) : []
  const [nextFilterId, setNextFilterId] = useState(3)
  const [email, setEmail] = useState("")
  const [identifier, setIdentifiers] = useState(3)
  const [responseTo, setResponseTo] = useState("")
  const tableContainerRef = useRef<HTMLDivElement | null>(null)

  // Track the currently focused input to prevent focus loss
  const [focusedInputId, setFocusedInputId] = useState<string | null>(null)
  const isFilterFormDirty = () => {
  // Check if any field in newFilter is non-empty
  return Object.values(newFilter).some(val => val !== "");
};
  const toggleTemplateNameEdit = () => {
    if (!isEditingTemplateName) {
      // When entering edit mode, set the initial value
      setEditedTemplateName(templateInfo?.templateName || "")
    } else {
      // When exiting edit mode, save the changes
      if (editedTemplateName.trim() !== "") {
        // Update templateInfo with the new name
        setTemplateInfo((prev: any) => ({
          ...prev,
          templateName: editedTemplateName,
        }))

        // Dispatch the update
        dispatch(
          updateTemplate({
            ...templateInfo,
            templateName: editedTemplateName,
          }),
        )
          .unwrap()
          .then(() => {
            toast.success("Template name updated successfully")
            dispatch(getTemplateInfobyID(selectedTemplate))
            .unwrap()
            .then((response: any) => {
           
              const allFields = response?.data?.fields || []
              setTemplateInfo(response?.data)
              setFields(allFields)
             })
          })
          .catch((error: any) => {
            console.error("Error updating template name:", error)
            toast.error("Error updating template name")
          })
      } else {
        // If empty, revert to original value
        setEditedTemplateName(templateInfo?.templateName || "")
        toast.warning("Template name cannot be empty")
      }
    }

    // Toggle edit mode
    setIsEditingTemplateName(!isEditingTemplateName)
  }
  const handleTemplateNameChange = (e: any) => {
    setEditedTemplateName(e.target.value)
  }

  // Fix the handleAddFilter function to properly structure new filter criteria
  const handleAddFilter = () => {
    setShowFilterSlider(true)
    /*     setNewFilter({
      operand1: "",
      parameter: "",
      operator: "",
      operand2: "",
    }) */
  }

 const handleSubmitFilterForm = () => {
    // Generate a unique ID for the new filter rule
    const newId = String(filterRules.length > 0 ? Math.max(...filterRules.map(r => Number(r.id))) + 1 : 1);
  
    // Determine operand2 value based on selected type or fixed value
    let operand2Value = "";
    if (newFilter.operator === "is-a") {
      operand2Value = newFilter.dataType;
    } else if (!newFilter.operand2Extractor) {
      operand2Value = newFilter.operand2Value;
    }

    // Construct the new filter criterion based on the form state
    const newCriterion: FilterCriterion = {
      
      operand1: {
        value: newFilter.operand1 ? "" : newFilter.fixedValue1 || "", // Use fixedValue1 if no extractor selected
        extractionStrategy: newFilter.operand1
          ? { // If operand1Extractor is selected
              extractorName: newFilter.operand1,
              parameters:
                newFilter.operand1 === "nthWord" || newFilter.operand1 === "Nth Word Size"
                  ? [newFilter.index] // Use index for nthWord extractors
                  : newFilter.parameter ? [newFilter.parameter] : [], // Use generic parameter for others
            }
          : null, // No extraction strategy if no extractor selected
      },
      operator: newFilter.operator || "",
      operand2: {
        value: operand2Value, // Use the determined operand2Value
        extractionStrategy: newFilter.operand2Extractor && newFilter.operator !== "is-a"
          ? { // If operand2Extractor is selected and operator is not 'is-a'
              extractorName: newFilter.operand2Extractor,
              parameters:
                newFilter.operand2Extractor === "nthWord" || newFilter.operand2Extractor === "Nth Word Size"
                  ? [newFilter.operand2Index] // Use operand2Index for nthWord extractors
                  : newFilter.operand2Parameter ? [newFilter.operand2Parameter] : [], // Use generic parameter for others
            }
          : null, // No extraction strategy if no extractor or if 'is-a'
      },
    };
  
    // Find the selected field in the current templateInfo state
    const selectedFieldItem = templateInfo.fields.find(
      (field: any) => field.fieldName === selectedField
    );
  
    if (!selectedFieldItem) {
      toast.error("Selected field not found in template data.");
      return;
    }
  
    // Create the updated filter strategy for the selected field by adding the new criterion
    // Ensure filterStrategy and filterCriteria exist
    const currentFilterStrategy = selectedFieldItem.filterStrategy || { filterCriteria: [], select: "all" };
    const updatedFilterCriteria = [...(currentFilterStrategy.filterCriteria || []), newCriterion];
  
    const updatedField = {
      ...selectedFieldItem,
      filterStrategy: {
        ...currentFilterStrategy,
        filterCriteria: updatedFilterCriteria,
        select: "all", // Assuming 'all' select
      },
    };
  
    // Create a copy of templateInfo with the updated field
    const updatedTemplateInfo = {
      ...templateInfo,
      fields: templateInfo.fields.map((field: any) => 
        field.fieldName === selectedField ? updatedField : field
      ),
    };
  
    // Dispatch the updateTemplate action
    dispatch(updateTemplate(updatedTemplateInfo))
      .unwrap()
      .then((response: any) => {
        // This block runs ONLY on successful API response
        if (response.status === 200) {
          toast.success("Filter saved successfully");
  
          // Refresh the template info from the backend to update the UI
          if (selectedTemplate) {
            dispatch(getTemplateInfobyID(selectedTemplate))
              .unwrap()
              .then((response: any) => {
                const allFields = response?.data?.fields || [];
                setTemplateInfo(response?.data);
                setFields(allFields); // This will trigger the useEffect to update filterRules
  
                setTimeout(() => {
                  if (tableContainerRef.current) {
                    const container = tableContainerRef.current;
                    container.scrollTop = container.scrollHeight;
                  }
                }, 100);
              })
              .catch((error: any) => {
                console.error("Error refreshing template data after save:", error);
                toast.error("Error refreshing dashboard after save");
              });
          }
        } else {
            // Handle cases where API call succeeds but returns an application-level error
            toast.error(`Failed to save filter: ${response.message || 'Unknown error'}`);
            console.error("API returned error status:", response);
        }
      })
      .catch((error: any) => {
        // This block runs ONLY on API call failure
        console.error("Error saving filter:", error);
        toast.error("Error saving filter");
        // Do NOT update UI state here, as the save failed.
      });
  
    // Close the modal and reset the form state immediately after dispatching the action
    setShowFilterSlider(false);
    setNewFilter({
      operand1: "",
      fixedValue1: "",
      parameter: "",
      operator: "",
      operand2: "", // This field is not used in the new logic, but keep for state reset
      fixedValue2: "", // This field is not used in the new logic, but keep for state reset
      index: "", // This field is for Operand 1 index, keep for state reset
      dataType: "",
      operand2Extractor: "",
      operand2Parameter: "",
      operand2Value: "",
      operand2Index: "",
    });
  };
  
  
  // Add a function to handle canceling the filter form
/*   const handleCancelFilterForm = () => {
    setNewFilter(initialFilterState); // Reset all dropdowns and fields
    setShowFilterSlider(false)
  }
 */
const handleCancelFilterForm = () => {
  console.log('Cancel filter form clicked. isFilterFormDirty:', isFilterFormDirty());
  if (isFilterFormDirty()) {
    setPendingCancel('filter');
    setShowUnsavedModal(true);
    setShowFilterSlider(true);
    console.log('UnsavedChangesModal should show');
  } else {
    setNewFilter(initialFilterState);
    setShowFilterSlider(false);
    console.log('Filter form reset and closed');
  }
};
  // Update the handleSubmitFilter function to add success/error messages
  const handleSubmitFilter = () => {
    // Save or validate filterRules
    setIsAddingFilter(false)

    dispatch(updateTemplate(templateInfo))
      .unwrap()
      .then(() => {
        toast.success("Filter saved successfully")
        
     /*    dispatch(getTemplateInfobyID(selectedTemplate))
        .unwrap()
        .then((response: any) => {
       
          const allFields = response?.data?.fields || []
          setTemplateInfo(response?.data)
          setFields(allFields)
         }) */
      })
      .catch((error: any) => {
        console.error("Error saving filter:", error)
        toast.error("Error saving filter")
      })
  }

  // Update the handleResetFilter function
  const handleResetFilter = () => {
    try {
      // Remove newly added filters or reset form
      const resetFilters = filterRules.filter((rule) => !rule.isNew)
      setFilterRules(resetFilters)
      setTemplateInfo((prev: any) => {
        const updatedFields = prev.fields.map((field: any) => {
          if (field.fieldName === selectedField && field.filterStrategy?.filterCriteria) {
            // Remove any filter criteria with isNew flag
            const updatedFilterCriteria = field.filterStrategy.filterCriteria.filter((criteria: any) => !criteria.isNew)

            return {
              ...field,
              filterStrategy: {
                ...field.filterStrategy,
                filterCriteria: updatedFilterCriteria,
                select: "all",
              },
            }
          }
          return field
        })

        return {
          ...prev,
          fields: updatedFields,
        }
      })

      setIsAddingFilter(false)
      toast.info("Filter changes reset")
    } catch (error) {
      console.error("Error resetting filters:", error)
      toast.error("Error resetting filters")
    }
  }

  // Add a new state to store the extractors data
  const [extractorOptions, setExtractorOptions] = useState<any[]>([])
  
  // Update extractor options when pdfParserAppData changes
  useEffect(() => {
    if (pdfParserAppData && Array.isArray(pdfParserAppData.extractors)) {
      const formattedExtractors = pdfParserAppData.extractors.map((extractor: any) => ({
        value: extractor.name,
        label: extractor.label || extractor.name,
      }));
      setExtractorOptions(formattedExtractors);
    }
  }, [pdfParserAppData]);
  const [filteroperations, setFilterOperations] = useState<any[]>([])
  const [operations, setOperations] = useState<any[]>([])

  // Add this state variable near the top where other state variables are defined:
  const [showTransformModal, setShowTransformModal] = useState(false)
  const [transformOperation, setTransformOperation] = useState("")
  const [transformParameters, setTransformParameters] = useState<string[]>([])
 
  useEffect(() => {

    if (fields.length > 0 && !selectedField) {
      const firstField = fields[0].fieldName
      setSelectedField(firstField)

      if (!fieldConfigTab) {
        setFieldConfigTab("fixedValue")
      }


      const field = fields.find((f: any) => f.fieldName === firstField)
      if (field) {
        setFixedValue(field.fixedValue || "")
      }
    }
    setPage(0)
    setTestPage(0)
  setJsonError(null);

    setTestRecordsField(0)
    setTestResultsField([])
   
  }, [fields, selectedField,selectedTemplate])
  useEffect(() => {
    if (selectedFieldExtract) {
      setJsonString(JSON.stringify(selectedFieldExtract, null, 2))
    }
  }, [selectedFieldExtract,selectedTemplate])
  useEffect(() => {
    if (fieldConfigTab === "editJSON" && selectedFieldExtract) {
      // Create an updated field extract that reflects the current state
      const updatedFieldExtract = {
        ...selectedFieldExtract,
        fixedValue: fixedValue,
        filterStrategy: {
          filterCriteria: [
            ...(templateInfo.fields
              .find((f: any) => f.fieldName === selectedField)?.filterStrategy?.filterCriteria || []),
            {
              operand1: {
                value: "",
                extractionStrategy: null,
              },
              operator: "",
              operand2: {
                value: "",
                extractionStrategy: null,
              },
            },
          ],
          select: "all"
        },
        extractionStrategy: templateInfo.fields
          .find((f: any) => f.fieldName === selectedField)?.extractionStrategy || null,
        transformationStrategy: templateInfo.fields
          .find((f: any) => f.fieldName === selectedField)?.transformationStrategy || null
      };
      
      // Update the selectedFieldExtract state
      setSelectedFieldExtract(updatedFieldExtract);
      
      // Update the JSON string
      setJsonString(JSON.stringify(updatedFieldExtract, null, 2));
    }
  }, [filterRules, extractorRules, transformRules, fieldConfigTab, selectedField, templateInfo?.fields,selectedTemplate]);
  useEffect(() => {
    if (fieldConfigTab === "editJSON" && selectedFieldExtract) {
      const updatedJson = {
        ...selectedFieldExtract,
        fixedValue: fixedValue,
      };
      setJsonString(JSON.stringify(updatedJson, null, 2)); // Update state to reflect JSON changes
    }
  }, [selectedFieldExtract, fixedValue, fieldConfigTab,selectedField]); // Run effect when relevant state change
  useEffect(() => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ""
    }
    if (fileInputIdentifier.current) {
      fileInputIdentifier.current.value = ""
    }
    if (fileInputRefTest.current) {
      fileInputRefTest.current.value = ""
    }
    if (fileInputRefMain.current) {
      fileInputRefMain.current.value = ""
    }
  }, [])
  // Add this new useEffect to specifically handle transformation rules updates
useEffect(() => {
  if (!selectedField || !fields?.length) return;

  const field = fields?.find((f: any) => f.fieldName === selectedField);
  if (!field) return;

  // Process transformation rules
  let transformationId = 1;
  const transformRulesArray: any[] = [];

  if (field.transformationStrategy?.transformationSteps?.length) {
    field.transformationStrategy.transformationSteps.forEach((step: any) => {
      const { operationName, parameters } = step;
      transformRulesArray.push({
        id: transformationId.toString(),
        step: operationName,
        parameter: parameters?.length > 0 ? parameters.join(", ") : "",
        isNew: false,
      });
      transformationId++;
    });
  }

  console.log(`Updating transform rules for field ${selectedField}:`, transformRulesArray);
  setTransformRules(transformRulesArray);
}, [selectedField, fields]);
// Add this new useEffect to specifically handle filter rules updates
useEffect(() => {
  if (!selectedField || !fields.length) return;

  const field = fields.find((f: any) => f.fieldName === selectedField);
  if (!field) return;

  // Process filter rules
  let filterId = 1;
  const filterRulesArray: any[] = [];

  if (field?.filterStrategy?.filterCriteria?.length) {
    console.log(`Processing filter criteria for field ${selectedField}:`, field.filterStrategy.filterCriteria);

    field.filterStrategy.filterCriteria.forEach((criteria: any) => {
      const operand1 = criteria.operand1 || {};
      const extractor = operand1.extractionStrategy || {};
      const extractorName = extractor.extractorName || "";
      const parameters = extractor.parameters || [];

      filterRulesArray.push({
        id: filterId.toString(),
        operand1: extractorName,
        parameter: parameters.join(", "),
        operator: criteria.operator || "",
        operand2: criteria.operand2?.value || "",
        isNew: false,
      });

      filterId++;
    });
  }

  console.log(`Updating filter rules for field ${selectedField}:`, filterRulesArray);
  setFilterRules(filterRulesArray);
}, [selectedField, fields]);
  const handleSaveEditedJson = () => {
    try {
      const jsonText = jsonString.trim()
  
      if (!jsonText) {
        toast.error("JSON content cannot be empty")
        return
      }
  
      console.log("JSON text to parse:", jsonText)
  
      let updatedFieldData: FieldData
      try {
        updatedFieldData = JSON.parse(jsonText) as FieldData
      } catch (parseError: any) {
        console.error("JSON parse error:", parseError)
        toast.error(`JSON parsing failed: ${parseError.message}`)
        return
      }
  
      if (!updatedFieldData || typeof updatedFieldData !== "object") {
        toast.error("Invalid JSON: must be an object")
        return
      }
  
      if (!updatedFieldData.fieldName) {
        toast.error("Invalid JSON: missing fieldName property")
        return
      }
  
      if (updatedFieldData.fieldName !== selectedField) {
        toast.error("Field name cannot be changed")
        return
      }
  
      // Update the local state variables BEFORE updating templateInfo
      // This ensures the UI is updated immediately
      
      // Update fixed value
      setFixedValue(updatedFieldData.fixedValue || "")
      
      // Update filter rules
      if (updatedFieldData.filterStrategy) {
        const filterCriteria = Array.isArray(updatedFieldData.filterStrategy) 
          ? updatedFieldData.filterStrategy 
          : (updatedFieldData.filterStrategy as FilterStrategy)?.filterCriteria || []
          
        const newFilterRules = filterCriteria.map((criteria: any, index: number) => ({
          id: criteria.id || String(index + 1),
          operand1: criteria.operand1?.extractionStrategy?.extractorName || "",
          parameter: criteria.operand1?.extractionStrategy?.parameters?.join(", ") || "",
          operator: criteria.operator || "",
          operand2: criteria.operand2?.value || "",
          isNew: false
        }))
        
        setFilterRules(newFilterRules)
      } else {
        setFilterRules([])
      }
      
      // Update extractor rules
      if (updatedFieldData.extractionStrategy?.extractorName) {
        const { extractorName, parameters } = updatedFieldData.extractionStrategy
        setExtractorRules([{
          id: "1",
          type: extractorName,
          parameter: parameters?.join(", ") || "",
          isNew: false
        }])
      } else {
        setExtractorRules([])
      }
      
      // Update transform rules
      if (updatedFieldData.transformationStrategy?.transformationSteps?.length) {
        const newTransformRules = updatedFieldData.transformationStrategy.transformationSteps.map((step: any, index: number) => ({
          id: String(index + 1),
          step: step.operationName,
          parameter: step.parameters?.join(", ") || "",
          isNew: false
        }))
        
        setTransformRules(newTransformRules)
      } else {
        setTransformRules([])
      }
  
      // Update the templateInfo state
      setTemplateInfo((prevState: any) => {
        const updatedFields = prevState.fields.map((field: any) => {
          if (field.fieldName === selectedField) {
            return {
              ...field,
              fixedValue: updatedFieldData.fixedValue || "",
              filterStrategy: {
                filterCriteria: Array.isArray(updatedFieldData.filterStrategy)
                  ? updatedFieldData.filterStrategy
                  : (updatedFieldData.filterStrategy as FilterStrategy)?.filterCriteria || [],
                select: "all",
              },
              extractionStrategy: updatedFieldData.extractionStrategy || null,
              transformationStrategy: updatedFieldData.transformationStrategy || null,
            }
          }
          return field
        })
  
        const updatedTemplate = {
          ...prevState,
          fields: updatedFields,
        }
  
        // Fire the API call using the updated template
        dispatch(updateTemplate(updatedTemplate))
          .unwrap()
          .then((response: any) => {
            if (response.status === 200) {
              toast.success("Field configuration saved successfully")
              setFieldConfigTab("fixedValue") // Switch to fixedValue tab to see changes
            } else {
              toast.error("Failed to save field configuration")
            }
          })
          .catch((err: any) => {
            console.error("Dispatch error:", err)
            toast.error("Something went wrong during save.")
          })
  
        return updatedTemplate
      })
  
      setSelectedFieldExtract(updatedFieldData)
      setJsonError(null)
    } catch (error: any) {
      console.error("Error in handleSaveEditedJson:", error)
      toast.error(`Error processing JSON: ${error.message}`)
    }
  }

  useEffect(() => {
    dispatch(getTemplateList())
      .unwrap()
      .then((response: any) => {
        setTemplates(response)
        console.log("responseee", response)
      })
    console.log("vvv", templateOptions)
  }, [location.pathname])
useEffect(()=>{
  setTestReadResults([])
 setTestFile(null)
 setIsEditingTemplateName(false)
 setIsEditingIdentifier(false)
   setIsEditingEmail(false)

},[])
useEffect(()=>{
  setTestReadResults([])
  setTestFile(null)
  setTestResults({})
  setIsEditingTemplateName(false)
  setIsEditingIdentifier(false)
    setIsEditingEmail(false)
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
  if (fileInputIdentifier.current) {
    fileInputIdentifier.current.value = "";
  }
  if (fileInputRefTest.current) {
    fileInputRefTest.current.value = "";
  }
  if (fileInputRefMain.current) {
    fileInputRefMain.current.value = "";
  }


},[selectedTemplate])

  useEffect(() => {
    if (pdfParserAppData) {
      // Format the filter operations data for the dropdown
      if (pdfParserAppData.filters) {
        const formattedFilterOperations = pdfParserAppData.filters.map((filter: any) => ({
          value: filter.name,
          label: filter.label || filter.name,
        }))
        setFilterOperations(formattedFilterOperations)
      }

      // Store data types for is-a condition
      if (pdfParserAppData.isAFilterOperands) {
        const formattedDataTypes = pdfParserAppData.isAFilterOperands.map((dataType: any) => ({
          value: dataType.name,
          label: dataType.label || dataType.name,
          description: dataType.description,
        }))
        setDataTypeOptions(formattedDataTypes)
      } else {
        setDataTypeOptions([])
      }
    }
  }, [pdfParserAppData])
  useEffect(() => {
    const styleElement = document.createElement("style")
    styleElement.innerHTML = `
      .read-results-table th:nth-child(1),
      .read-results-table td:nth-child(1) {
        width: 80px !important;
        min-width: 80px !important;
      }
      
      .read-results-table th:nth-child(2),
      .read-results-table td:nth-child(2) {
        width: 150px !important;
        min-width: 150px !important;
      }
      
      .read-results-table th:nth-child(3),
      .read-results-table td:nth-child(3) {
        width: 150px !important;
        min-width: 150px !important;
      }
      
      .read-results-table th:nth-child(4),
      .read-results-table td:nth-child(4) {
        width: 1000px !important;
        min-width: 1000px !important;
      }
      
      .read-results-table {
        min-width: 1380px !important;
      }
      
      .read-results-container {
        height: 600px !important;
        overflow-y: auto !important;
        overflow-x: auto !important;
      }
      .read-results-table td {
        white-space: normal !important;
        word-break: break-word !important;
        max-width: none !important;
        overflow: visible !important;
      }
      .read-results-table th:nth-child(4),
      .read-results-table td:nth-child(4) {
        width: auto !important;
        min-width: 500px !important;
        max-width: none !important;
      }
    `
    document.head.appendChild(styleElement)

    return () => {
      document.head.removeChild(styleElement)
    }
  }, [])
  const handleExtractorModalSubmit = (extractorType: string, parameter: string) => {
    // Close the modal immediately
    setShowExtractorModal(false)

    // Create a copy of the updated templateInfo to use in the dispatch
    const updatedTemplateInfo = { ...templateInfo }

    // Update the copy with the new extractor
    updatedTemplateInfo.fields = templateInfo.fields.map((field: any) => {
      if (field.fieldName === selectedField) {
        return {
          ...field,
          extractionStrategy: {
            extractorName: extractorType,
            parameters: parameter ? [parameter] : [],
          },
        }
      }
      return field
    })

    // Dispatch the update with the updated copy
    dispatch(updateTemplate(updatedTemplateInfo))
      .unwrap()
      .then(() => {
        toast.success("Extractor added successfully")

        // Only update the UI after successful API call
        const newId = extractorRules.length + 1

        // Create the new extractor rule
        const newExtractorRule = {
          id: newId.toString(),
          type: extractorType,
          parameter: parameter,
          isNew: false, // Set to false immediately to prevent editing
        }

        // Update extractorRules state
        setExtractorRules([newExtractorRule])

        // Set isAddingExtract to false to disable editing
        setIsAddingExtract(false)

        // Refresh the dashboard with the newly added extractor
        if (selectedTemplate) {
          dispatch(getTemplateInfobyID(selectedTemplate))
            .unwrap()
            .then((response: any) => {
              const allFields = response?.data?.fields || []
              setTemplateInfo(response?.data)
              setFields(allFields)

              // Re-process the extractor rules for the selected field
              if (selectedField) {
                const selected = allFields.find((item: any) => item.fieldName === selectedField)
                if (selected?.extractionStrategy?.extractorName) {
                  const { extractorName, parameters } = selected.extractionStrategy

                  const updatedExtractorRules = [
                    {
                      id: "1",
                      type: extractorName,
                      parameter: parameters?.length > 0 ? parameters.join(", ") : "",
                      isNew: false,
                    },
                  ]

                  setExtractorRules(updatedExtractorRules)
                }
              }
              setTimeout(() => {
                if (tableContainerRef.current) {
                  const container = tableContainerRef.current
                  container.scrollTop = container.scrollHeight
                }
              }, 100)
            })
            .catch((error: any) => {
              console.error("Error refreshing template data:", error)
              toast.error("Error refreshing dashboard")
            })
        }
      })
      .catch((error: any) => {
        console.error("Error saving extractor:", error)
        toast.error("Error saving extractor")
        // Don't update UI on error - just show the toast
      })
  }
  // Add this at the top of your component
  const latestDataRef = useRef(null)

  // Add a helper function to set the transform modal state
  const setShowTransformModalState = (value: boolean) => {
    setShowTransformModal(value)
  }

  // Add this useEffect to refresh data when template is selected
  useEffect(() => {
    if (!selectedTemplate) return

    dispatch(getTemplateInfobyID(selectedTemplate))
      .unwrap()
      .then((response: any) => {
        const allFields = response?.data?.fields || []

        // Store the data in a ref immediately
        latestDataRef.current = response?.data

        setTemplateInfo(latestDataRef.current)
        setEmail(response?.data?.emails)
        setIdentifiers(response?.data?.identifiers)
        setResponseTo(response?.data?.responseTo)
        setFields(allFields)

        // Log from the ref
        console.log("Latest template data:", latestDataRef.current)
      })
  }, [selectedTemplate])

  // Update the useEffect that processes the transformation steps to properly extract the operation name
  useEffect(() => {
    if (!fields.length || !selectedField) return

    console.log("Processing field data for:", selectedField)



    // Get the most up-to-date field data
    const selected = fields.find((item: any) => item.fieldName === selectedField)
    if (!selected) {
      console.warn("Selected field not found:", selectedField)
      return
    }

    setFixedValue(selected.fixedValue || "")

    // Process filter rules with fresh state
    let filterId = 1
    const selectedFilterRules: any[] = []

    if (selected?.filterStrategy?.filterCriteria?.length) {
      console.log("Processing filter criteria:", selected.filterStrategy.filterCriteria)

      selected.filterStrategy.filterCriteria.forEach((criteria: any) => {
        const operand1 = criteria.operand1 || {}
        const extractor = operand1.extractionStrategy || {}
        const extractorName = extractor.extractorName || ""
        const parameters = extractor.parameters || []

        selectedFilterRules.push({
          id: filterId.toString(),
          operand1: extractorName,
          parameter: parameters.join(", "),
          operator: criteria.operator || "",
          operand2: criteria.operand2?.value || "",
          isNew: false,
        })

        filterId++
      })
    }

    // Update state with processed data
    setFilterRules(selectedFilterRules)

    // Process extractor rules
    let extractorRulesArray: any[] = []
    if (selected?.extractionStrategy?.extractorName) {
      const { extractorName, parameters } = selected.extractionStrategy
      extractorRulesArray = [
        {
          id: "1",
          type: extractorName,
          parameter: parameters?.length > 0 ? parameters.join(", ") : "",
          isNew: false,
        },
      ]
    }
    setExtractorRules(extractorRulesArray)

    // Process transformation rules
    let transformationId = 1
    const transformRulesArray: any[] = []
    if (selected?.transformationStrategy?.transformationSteps?.length) {
      selected.transformationStrategy.transformationSteps.forEach((step: any) => {
        const { operationName, parameters } = step
        transformRulesArray.push({
          id: transformationId.toString(),
          step: operationName,
          parameter: parameters?.length > 0 ? parameters.join(", ") : "",
          isNew: false,
        })
        transformationId++
      })
    }
    setTransformRules(transformRulesArray)

    // Update selected field extract
    if (selected) {
      const extractedData = {
        fieldName: selected.fieldName,
        fixedValue: selected.fixedValue || "",
        filterStrategy: selected.filterStrategy?.filterCriteria || [],
        extractionStrategy: selected.extractionStrategy || {},
        transformationStrategy: selected.transformationStrategy || null,
      }
      setSelectedFieldExtract(extractedData)

      // Update JSON string if in edit mode
      if (fieldConfigTab === "editJSON") {
        setJsonString(JSON.stringify(extractedData, null, 2))
      }
    }
  }, [fields,selectedField])
// Add this new useEffect to specifically handle extractor rules updates
useEffect(() => {
  if (!selectedField || !fields.length) return;

  const field = fields.find((f: any) => f.fieldName === selectedField);
  if (!field) return;

  // Process extractor rules
  let extractorRulesArray: any[] = [];
  
  if (field?.extractionStrategy?.extractorName) {
    console.log(`Processing extractor for field ${selectedField}:`, field.extractionStrategy);
    
    const { extractorName, parameters } = field.extractionStrategy;
    extractorRulesArray = [
      {
        id: "1",
        type: extractorName,
        parameter: parameters?.length > 0 ? parameters.join(", ") : "",
        isNew: false,
      },
    ];
  }

  console.log(`Updating extractor rules for field ${selectedField}:`, extractorRulesArray);
  setExtractorRules(extractorRulesArray);
}, [selectedField, fields]);
  // Update the handleInputChange function to properly handle all form fields
  // Replace the existing handleInputChange function with this one:
  const handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setNewFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }))
  }
  // Handle file change and dispatch action
  const handleFileChangeTestByField = (event: any) => {
    setTestError(''); // Clear previous error
    setTestResultsField([]); // Clear previous results
    setTestRecordsField(0);
    const file = event.target.files[0];
    if (file) {
      console.log("File selected:", file.name)
      // Show loading state
      //  setTestResults([]);
      // setTestRecords(0);

      // Create a FormData object to properly handle file upload
      const formData = new FormData()
      formData.append("file", file)
      formData.append("selectedTemplate", templateInfo?.templateName || "")
      formData.append("selectedField", selectedField || "")

      // Log the payload for debugging
      console.log("Payload:", {
        file: file.name,
        selectedTemplate: templateInfo?.templateName,
        selectedField: selectedField,
      })

      // Dispatch the API call
      dispatch(
        getTemplateParseByFieldName({
          file,
          selectedTemplate: templateInfo?.templateName,
          selectedField,
        }),
      )
        .then((response: any) => {
          console.log("API response:", response)

          // Always set testResultsField to the full payload for the JSON display area
          const payloadData = response.payload?.data?.result || response.payload?.data || response.payload;
          setTestResultsField(Array.isArray(payloadData) ? payloadData : [payloadData]);

          // First, check for explicit API errors within the payload
          const apiErrorMessage =
            (response?.payload?.error && typeof response.payload.error === 'string' && response.payload.error.trim().length > 0) ? response.payload.error :
            (response?.payload?.data?.error && typeof response.payload.data.error === 'string' && response.payload.data.error.trim().length > 0) ? response.payload.data.error :
            null;

          if (apiErrorMessage) {
            toast.error(apiErrorMessage);
            setTestError(apiErrorMessage); // Set error for UI
            setTestResultsField([]); // Clear results if it's an error
            setTestRecordsField(0);
            return;
          }

          let dataForRecordCounting = null; // Separate variable for record counting logic

          // Robustly check if data is directly in payload.data (preferred) or payload itself for record counting
          if (response?.payload?.data) {
            dataForRecordCounting = response.payload.data.result !== undefined ? response.payload.data.result : response.payload.data;
          } else if (response?.payload) {
            dataForRecordCounting = response.payload;
          }

          // Process the data for record counting and display appropriate toast
          if (dataForRecordCounting !== null && dataForRecordCounting !== undefined) {
            // Update the record count and display appropriate toast
            setTestRecordsField(Array.isArray(dataForRecordCounting) ? dataForRecordCounting.length : 0)
            // Show success message
            if (Array.isArray(dataForRecordCounting) && dataForRecordCounting.length > 0) {
              toast.success(`Successfully parsed ${dataForRecordCounting.length} records`)
            } else {
              toast.info("No records found in the parsed template"); // Informational for empty array or object
            }
          } else {
           
            toast.error(apiErrorMessage);
            setTestResultsField([]); // Clear results if no data
            setTestRecordsField(0);
          }
        })
        .catch((error: any) => {
          const errMsg = error?.response?.data?.error || "Failed to parse template. Please try again.";
          toast.error(errMsg);
          setTestError(errMsg); // Set error for UI
          setTestResultsField([]);
          setTestRecordsField(0);
        })
    }
  }
useEffect(() => {
  if (fileInputRefTest.current) {
    fileInputRefTest.current.value = ""; // Clear the input so re-uploads trigger `onChange`
  }
}, [selectedField]); // or fieldName

  const handleFileChangeTest = (event: any) => {
    setTestError(''); // Clear previous error
    setTestResults([]); // Clear previous results
    setTestRecords(0);
    const file = event.target.files[0];
    if (file) {
      console.log("File selected:", file.name)
      // Show loading state
      setTestResults([])
      setTestRecords(0)

      // Create a FormData object to properly handle file upload
      const formData = new FormData()
      formData.append("file", file)
      formData.append("selectedTemplate", templateInfo?.templateName || "")

      // Log the payload for debugging
      console.log("Payload:", {
        file: file.name,
        selectedTemplate: templateInfo?.templateName,
      })

      // Dispatch the API call
      dispatch(
        getTemplateParse({
          file,
          selectedTemplate: templateInfo?.templateName,
        })
      )
        .then((action: any) => {
          const payload = action.payload;
          if (action?.error) {
            toast.error(action.error.message);
            setTestError(action.error.message); // Set error for UI
            setTestResults([]);
            setTestRecords(0);
            return;
          }
          // If result exists inside data, display that
          if (payload?.data?.result) {
            setTestResults(payload.data.result);
            setTestRecords(Array.isArray(payload.data.result) ? payload.data.result.length : 1);
          } else {
            // Otherwise show the whole data or payload
            const resultData = payload?.data || payload;
            setTestResults(resultData);
            setTestRecords(Array.isArray(resultData) ? resultData.length : 1);
          }
        })
        .catch((error: any) => {
          const errorMessage = error?.response?.data?.error || "Failed to parse template. Please try again.";
          toast.error(errorMessage);
          setTestError(errorMessage); // Set error for UI
          setTestResults([]);
          setTestRecords(0);
        });
    }
  }
  const cancelTemplateNameEdit = () => {
    // Reset the edited template name to the original value
    setEditedTemplateName(templateInfo?.templateName || "")
    // Exit edit mode
    setIsEditingTemplateName(false)
  }
  const cancelIdentifierEdit = () => {
    
    setIdentifiers(identifier)
    setIsEditingIdentifier(false)
  }
  const cancelEmailEdit = () => {
    // Reset the edited template name to the original value
    setEmail(email)
    // Exit edit mode
    setIsEditingEmail(false)
  }

  const cancelResponseToEdit = () => {
    // Reset the responseTo to the original value
    setResponseTo(templateInfo?.responseTo || "")
    // Exit edit mode
    setIsEditingResponseTo(false)
  }
  useEffect(() => {
    if (testReadResults.length > 0) {
      console.log("Updated testReadResults:", testReadResults)
    }
  }, [testReadResults]) // This will run whenever testReadResults changes
  const handleEmailChange = (e: any) => {
    const newEmail = e.target.value
    setEmail(newEmail)

    // Update templateInfo directly when email changes
    setTemplateInfo((prev: any) => ({
      ...prev,
      emails: newEmail,
    }))
  }
  const handleIdentifierChange = (e: any) => {
    const newIdentifier = e.target.value
    setIdentifiers(newIdentifier)

    // Update templateInfo directly when identifier changes
    setTemplateInfo((prev: any) => ({
      ...prev,
      identifiers: newIdentifier,
    }))
  }

  const handleResponseToChange = (e: any) => {
    setResponseTo(e.target.value);
  }

  const toggleResponseToEdit = () => {
    setIsEditingResponseTo(!isEditingResponseTo);

    // Only save if we're exiting edit mode
    if (isEditingResponseTo) {
      const updatedTemplateInfo = {
        ...templateInfo,
        responseTo: responseTo || null,
      };

      dispatch(updateTemplate(updatedTemplateInfo))
        .unwrap()
        .then(() => {
          setTemplateInfo(updatedTemplateInfo);
          toast.success("Response To updated successfully");
        })
        .catch((error: any) => {
          toast.error("Failed to update Response To");
        });
    }
  }

  // Add these new functions to handle toggling edit mode
  const toggleEmailEdit = () => {
    setIsEditingEmail(!isEditingEmail)

    // If we're exiting edit mode, save the changes
    if (isEditingEmail) {
      dispatch(updateTemplate(templateInfo))
        .unwrap()
        .then(() => {
          toast.success("Email updated successfully")
       /*    dispatch(getTemplateInfobyID(selectedTemplate))
          .unwrap()
          .then((response: any) => {
         
            const allFields = response?.data?.fields || []
            setTemplateInfo(response?.data)
            setFields(allFields)
           }) */
        })
        .catch((error: any) => {
          console.error("Error updating email:", error)
          toast.error("Error updating email")
        })
    }
  }

  const toggleIdentifierEdit = () => {
    setIsEditingIdentifier(!isEditingIdentifier)

    // If we're exiting edit mode, save the changes
    if (isEditingIdentifier) {
      dispatch(updateTemplate(templateInfo))
        .unwrap()
        .then(() => {
          toast.success("Identifier updated successfully")
        /*   dispatch(getTemplateInfobyID(selectedTemplate))
          .unwrap()
          .then((response: any) => {
         
            const allFields = response?.data?.fields || []
            setTemplateInfo(response?.data)
            setFields(allFields)
           }) */
        })
        .catch((error: any) => {
          console.error("Error updating identifier:", error)
          toast.error("Error updating identifier")
        })
    }
  }



  // Replace the handleSaveEmail and handleSaveIdentifier functions since we'll save on toggle
  const handleSaveEmail = toggleEmailEdit
  const handleSaveIdentifier = toggleIdentifierEdit

  const handleValidateIdentifier = async (event: any) => {
    const file = event.target.files[0]

    if (file) {
      const payload = {
        file: file,
        selectedTemplate: templateInfo?.templateName,
      }

      try {
        const response = await dispatch(validateIdentifers(payload))

        const result = response?.payload?.data?.result
        const status = response?.status
        console.log("responseee", response?.payload?.status)
        if (response?.payload?.status === 200) {
          toast.success("Identifier matched successfully!")
        } else {
          toast.error("No identifier matched.")
        }
      } catch (error) {
        toast.error("Error validating identifier.")
        console.error("Error parsing template:", error)
        event.target.value = null
      }
    }
  }
  const handleRead = async (event: any) => {
    const file = event.target.files[0]

    if (file) {
      setTestFile(file)

      const payload = {
        file: file,
      }

      try {
        // Set loading state
        setTestReadResults([])
        setTestReadRecords(0)

        const response = await dispatch(readTemplate(payload))

        // Log the full response to see its structure
        console.log("Read template response:", response?.payload?.data)

        // Check if we have textRecords in the response
        const textRecords = response?.payload?.data?.textRecords || []

        if (Array.isArray(textRecords) && textRecords.length > 0) {
          // Format the data for the table
          const formattedData: any = textRecords.map((record, index) => ({
            id: index + 1,
            pageNumber: record.pageNumber,
            lineNumber: record.lineNumber,
            text: record.text,
          }))

          // Log the formatted data before setting state
          console.log("Formatted data:", formattedData)

          // Update state with the formatted data
          setTestReadResults(formattedData)
          setTestReadRecords(formattedData.length)
        } else {
          console.warn("No text records found in the response")
          setTestReadResults([])
          setTestReadRecords(0)
        }
      } catch (error) {
        console.error("Error reading template:", error)
        setTestReadResults([])
        setTestReadRecords(0)
      }
    }
  }

  useEffect(() => {
    setIsAddingExtract(false)
    setIsAddingFilter(false)
    setIsAddingTransform(false)
  }, [fieldConfigTab])

  // Modify the handleAddTransformation function to show the modal instead of directly adding the transformation
  const handleAddTransformation = () => {
    setTransformOperation("")
    setTransformParameters([])
    setShowTransformModal(true)
  }

  const handleDeleteTransformation = async (index: number) => {
    try {
      // Optimistically update UI
      const currentRules = [...transformRules];
      currentRules.splice(index, 1);
      setTransformRules(currentRules);

      const response = await dispatch(getTemplateInfobyID(selectedTemplate)).unwrap();
      const freshTemplate = response?.data;
  
      if (!freshTemplate || !Array.isArray(freshTemplate.fields)) {
        // Revert UI on error
        setTransformRules(transformRules);
        toast.error("Invalid template data received");
        return;
      }
  
      const fieldIndex = freshTemplate.fields.findIndex(
        (field: any) => field.fieldName === selectedField
      );
  
      if (fieldIndex === -1) {
        // Revert UI on error
        setTransformRules(transformRules);
        toast.error("Field not found");
        return;
      }

      const currentField = freshTemplate.fields[fieldIndex];
      const currentSteps = currentField.transformationStrategy?.transformationSteps || [];
      const updatedSteps = currentSteps.filter((_: any, idx: number) => idx !== index);

      const updatedTemplate = {
        ...freshTemplate,
        fields: freshTemplate.fields.map((field: any, idx: number) => {
          if (idx === fieldIndex) {
            return {
              ...field,
              transformationStrategy: {
                ...field.transformationStrategy,
                transformationSteps: updatedSteps
              }
            };
          }
          return field;
        })
      };

      await dispatch(updateTemplate(updatedTemplate)).unwrap();
      toast.success("Transformation deleted successfully");

      // Update template info
      setTemplateInfo(updatedTemplate);
      setFields(updatedTemplate.fields);

      const updatedField = updatedTemplate.fields[fieldIndex];
      if (updatedField && fieldConfigTab === "editJSON") {
        setJsonString(JSON.stringify(updatedField, null, 2));
      }
    } catch (error: any) {
      // Revert UI on error
      setTransformRules(transformRules);
      console.error("Delete failed:", error);
      toast.error(error?.message || "Error deleting transformation");
    }
  };

const handleSubmitTransformModal = () => {
  const selectedFieldItem = templateInfo.fields.find(
    (field: any) => field.fieldName === selectedField
  );

  if (!selectedFieldItem) {
    toast.error("Selected field not found in template data.");
    return;
  }

  // Always use transformParameters for parameters
  const processedParameters = transformParameters.map(param => param || "");
  console.log("Submitting with transformParameters:", transformParameters);
  console.log("Payload for operation:", transformOperation, processedParameters);

  // Normalize all existing steps to only have { operationName, parameters }
  const currentTransformStrategy = selectedFieldItem.transformationStrategy || { transformationSteps: [] };
  const normalizedSteps = (currentTransformStrategy.transformationSteps || [])
    .map((step: any) => ({
      operationName: step.operationName || step.operation,
      parameters: step.parameters || []
    }))
    .filter((step: any) => !!step.operationName);
  const newStep = {
    operationName: transformOperation,
    parameters: processedParameters
  };
  const updatedSteps = [...normalizedSteps, newStep];

  const updatedField = {
    ...selectedFieldItem,
    transformationStrategy: {
      ...currentTransformStrategy,
      transformationSteps: updatedSteps
    }
  };

  const updatedTemplateInfo = {
    ...templateInfo,
    fields: templateInfo.fields.map((field: any) => 
      field.fieldName === selectedField ? updatedField : field
    )
  };

  dispatch(updateTemplate(updatedTemplateInfo))
    .unwrap()
    .then((response: any) => {
      if (response.status === 200) {
        toast.success("Transformation saved successfully");
        setShowTransformModal(false);
        setTransformOperation("");
        setTransformParameters([]);
        setCharacterToReplace("");
        setReplaceWithCharacter("");

        if (selectedTemplate) {
          dispatch(getTemplateInfobyID(selectedTemplate))
            .unwrap()
            .then((response: any) => {
              const allFields = response?.data?.fields || [];
              setTemplateInfo(response?.data);
              setFields(allFields);
            })
            .catch((error: any) => {
              console.error("Error refreshing template data:", error);
              toast.error("Error refreshing dashboard");
            });
        }
      } else {
        toast.error(`Failed to save transformation: ${response.message || 'Unknown error'}`);
      }
    })
    .catch((error: any) => {
      console.error("Error saving transformation:", error);
      toast.error("Error saving transformation");
    });
};
  const handleResetTransformation = () => {
    // Remove any rules with isNew flag
    setTransformRules((prev) => prev.filter((rule) => !rule.isNew))
    setIsAddingTransform(false)
  }
  const fieldColumns = [
    {
      accessor: "fieldName",
     
      Cell: ({ row }: any) => {
        const isSelected = selectedField === row.original.fieldName
        return (
          <div
            title={row.original.fieldName}
            className="text-primary cursor-pointer"
            onClick={() => handleFieldSelect(row.original.fieldName)}
            style={{
              fontWeight: isSelected ? "bold" : "normal",
              fontSize: "1rem",
              backgroundColor: isSelected ? "#e9f5ff" : "transparent",
            //  whiteSpace: "normal",
            //  wordBreak: "break-word",
             // overflowWrap: "break-word",
            }}
          >
            {row.original.fieldName}
          </div>
        )
      },
      minWidth: 300,
      width: 500,
      maxWidth: 700,
    },
  ]

  // Update the handleSubmitTransformation function
  const handleSubmitTransformation = () => {
    // Save or validate transformRules
    setIsAddingTransform(false)

    dispatch(updateTemplate(templateInfo))
      .unwrap()
      .then(() => {
        toast.success("Transformation saved successfully")
       /*  dispatch(getTemplateInfobyID(selectedTemplate))
        .unwrap()
        .then((response: any) => {
       
          const allFields = response?.data?.fields || []
          setTemplateInfo(response?.data)
          setFields(allFields)
         }) */
      })
      .catch((error: any) => {
        console.error("Error saving transformation:", error)
        toast.error("Error saving transformation")
      })
  }
  const handleAddExtractor = () => {
    if (extractorRules.length === 0) {
      setExtractorType("");
      setExtractorParameter("");
      setShowExtractorModal(true);
    } else {
      toast.info("Only one extractor can be added per field. Please edit the existing one.");
    }
  };

  const handleDeleteExtractor = async () => {
    try {
      // Optimistically update UI
      setExtractorRules([]);

      const response = await dispatch(getTemplateInfobyID(selectedTemplate)).unwrap();
      const freshTemplate = response?.data;
  
      if (!freshTemplate || !Array.isArray(freshTemplate.fields)) {
        // Revert UI on error
        setExtractorRules(extractorRules);
        toast.error("Invalid template data received");
        return;
      }
  
      const fieldIndex = freshTemplate.fields.findIndex(
        (field: any) => field.fieldName === selectedField
      );
  
      if (fieldIndex === -1) {
        // Revert UI on error
        setExtractorRules(extractorRules);
        toast.error("Field not found");
        return;
      }

      const updatedTemplate = {
        ...freshTemplate,
        fields: freshTemplate.fields.map((field: any, idx: number) => {
          if (idx === fieldIndex) {
            return {
              ...field,
              extractionStrategy: null
            };
          }
          return field;
        })
      };

      await dispatch(updateTemplate(updatedTemplate)).unwrap();
      toast.success("Extractor deleted successfully");

      // Update template info
      setTemplateInfo(updatedTemplate);
      setFields(updatedTemplate.fields);

      if (fieldConfigTab === "editJSON") {
        setJsonString(JSON.stringify(updatedTemplate.fields[fieldIndex], null, 2));
      }
    } catch (error: any) {
      // Revert UI on error
      setExtractorRules(extractorRules);
      console.error("Delete failed:", error);
      toast.error(error?.message || "Error deleting extractor");
    }
  };

  const handleSubmitExtractor = () => {
    const selectedFieldItem = templateInfo.fields.find(
      (field: any) => field.fieldName === selectedField
    );
  
    if (!selectedFieldItem) {
      toast.error("Selected field not found in template data.");
      return;
    }

    const newExtractor = {
      extractorName: extractorType,
      parameters: extractorParameter.split(",").map((param: string) => param.trim())
    };

    const updatedField = {
      ...selectedFieldItem,
      extractionStrategy: newExtractor
    };

    const updatedTemplateInfo = {
      ...templateInfo,
      fields: templateInfo.fields.map((field: any) => 
        field.fieldName === selectedField ? updatedField : field
      )
    };

    dispatch(updateTemplate(updatedTemplateInfo))
      .unwrap()
      .then((response: any) => {
        if (response.status === 200) {
          toast.success("Extractor saved successfully");
          setShowExtractorModal(false);
          setExtractorType("");
          setExtractorParameter("");

          if (selectedTemplate) {
            dispatch(getTemplateInfobyID(selectedTemplate))
              .unwrap()
              .then((response: any) => {
                const allFields = response?.data?.fields || [];
                setTemplateInfo(response?.data);
                setFields(allFields);
              })
              .catch((error: any) => {
                console.error("Error refreshing template data:", error);
                toast.error("Error refreshing dashboard");
              });
          }
        } else {
          toast.error(`Failed to save extractor: ${response.message || 'Unknown error'}`);
        }
      })
      .catch((error: any) => {
        console.error("Error saving extractor:", error);
        toast.error("Error saving extractor");
      });
  };

  const handleResetExtractor = () => {
    // Remove any rules with isNew flag
    setExtractorRules((prev) => prev.filter((rule) => !rule.isNew))
    setIsAddingExtract(false)
  }

  // Fix the handleUpdateTransformation function to accept field and value parameters
  const handleUpdateTransformation = (index: number, field: string, value: string) => {
    // Store the current focused input ID to maintain focus
    const inputId = `${index}-${field}`;
    setFocusedInputId(inputId);

    // Update the UI state
    setTransformRules((prev) => prev.map((rule, idx) => 
      idx === index ? { ...rule, [field]: value } : rule
    ));

    // Update templateInfo state with the correct structure
    setTemplateInfo((prev: any) => {
      const updatedFields = prev.fields.map((fieldItem: any) => {
        if (fieldItem.fieldName === selectedField) {
          // Initialize transformationStrategy if it doesn't exist
          const currentTransformStrategy = fieldItem.transformationStrategy || { transformationSteps: [] };
          const currentSteps = [...(currentTransformStrategy.transformationSteps || [])];

          // Ensure the index exists in the array
          while (currentSteps.length <= index) {
            currentSteps.push({ operationName: "", parameters: [] });
          }

          // Update the specific step based on the field being changed
          if (field === "step") {
            currentSteps[index] = {
              ...currentSteps[index],
              operationName: value,
              parameters: currentSteps[index].parameters || [],
            };
          } else if (field === "parameter") {
            currentSteps[index] = {
              ...currentSteps[index],
              operationName: currentSteps[index].operationName || "",
              parameters: value ? [value] : [],
            };
          }

          return {
            ...fieldItem,
            transformationStrategy: {
              ...currentTransformStrategy,
              transformationSteps: currentSteps,
            },
          };
        }
        return fieldItem;
      });

      return {
        ...prev,
        fields: updatedFields,
      };
    });
  };

  useEffect(() => {
    if (selectedField) {
      // Find the field in templateInfo.fields or fields array
      const field = (templateInfo?.fields || fields)?.find((f: any) => f?.fieldName === selectedField);
      if (field) {
        setFixedValue(field.fixedValue || "");
      }
    }
  }, [selectedField, templateInfo, fields, selectedTemplate]);
  const handleDeleteFilter = async (index: number) => {
    try {
      // Optimistically update UI
      const currentRules = [...filterRules];
      currentRules.splice(index, 1);
      setFilterRules(currentRules);

      const response = await dispatch(getTemplateInfobyID(selectedTemplate)).unwrap();
      const freshTemplate = response?.data;
  
      if (!freshTemplate || !Array.isArray(freshTemplate.fields)) {
        // Revert UI on error
        setFilterRules(filterRules);
        toast.error("Invalid template data received");
        return;
      }
  
      const fieldIndex = freshTemplate.fields.findIndex(
        (field: any) => field.fieldName === selectedField
      );
  
      if (fieldIndex === -1) {
        // Revert UI on error
        setFilterRules(filterRules);
        toast.error("Field not found");
        return;
      }

      const currentField = freshTemplate.fields[fieldIndex];
      const currentCriteria = currentField.filterStrategy?.filterCriteria || [];
      const updatedCriteria = currentCriteria.filter((_: any, idx: number) => idx !== index);

      const updatedTemplate = {
        ...freshTemplate,
        fields: freshTemplate.fields.map((field: any, idx: number) => {
          if (idx === fieldIndex) {
            return {
              ...field,
              filterStrategy: {
                ...field.filterStrategy,
                filterCriteria: updatedCriteria,
                select: "all"
              }
            };
          }
          return field;
        })
      };

      await dispatch(updateTemplate(updatedTemplate)).unwrap();
      toast.success("Filter deleted successfully");

      // Update template info
      setTemplateInfo(updatedTemplate);
      setFields(updatedTemplate.fields);

      if (fieldConfigTab === "editJSON") {
        setJsonString(JSON.stringify(updatedTemplate.fields[fieldIndex], null, 2));
      }
    } catch (error: any) {
      // Revert UI on error
      setFilterRules(filterRules);
      console.error("Delete failed:", error);
      toast.error(error?.message || "Error deleting filter");
    }
  };
  
  
  const handleExtractTabClick = () => {
    setFieldConfigTab("extract")
  }

  // Fix the handleUpdateFilter function to properly update the filter criteria structure
  const handleUpdateFilter = (id: string, field: string, value: string) => {
    // Create a unique identifier for the input field
    const inputId = `${id}-${field}`

    // Update the filterRules state without losing focus
    setFilterRules((prev: any) => prev.map((rule: any) => (rule.id === id ? { ...rule, [field]: value } : rule)))

    // Update the templateInfo state with the correct structure
    setTemplateInfo((prev: any) => {
      // Find the selected field within the fields array
      const updatedFields = prev.fields.map((fieldItem: any) => {
        if (fieldItem.fieldName === selectedField) {
          // If no filterStrategy exists yet, create a structure
          const currentFilterStrategy = fieldItem.filterStrategy || { filterCriteria: [], select: "all" }
          const currentCriteria = currentFilterStrategy.filterCriteria || []

          // Find the specific filter rule by ID and update it
          const updatedFilterCriteria = currentCriteria.map((criteria: any) => {
            // Check if this is the criteria we need to update
            if (criteria.id === id) {
              // Create updated criteria based on which field is being changed
              if (field === "operand1") {
                return {
                  ...criteria,
                  operand1: {
                    value: "",
                    extractionStrategy: {
                      extractorName: value, // Set the extractor name
                      parameters: criteria.operand1?.extractionStrategy?.parameters || [],
                    },
                  },
                }
              } else if (field === "parameter") {
                return {
                  ...criteria,
                  operand1: {
                    value: "",
                    extractionStrategy: {
                      extractorName: criteria.operand1?.extractionStrategy?.extractorName || "",
                      parameters: value ? [value] : [], // Set the parameters as an array
                    },
                  },
                }
              } else if (field === "operator") {
                return {
                  ...criteria,
                  operator: value,
                }
              } else if (field === "operand2") {
                return {
                  ...criteria,
                  operand2: {
                    value: value,
                    extractionStrategy: null,
                  },
                }
              }
            }
            return criteria
          })

          return {
            ...fieldItem,
            filterStrategy: {
              ...currentFilterStrategy,
              filterCriteria: updatedFilterCriteria,
              select: "all",
            },
          }
        }
        return fieldItem
      })

      return {
        ...prev,
        fields: updatedFields,
      }
    })

    // Store the current focused input ID
    setFocusedInputId(inputId)
  }

  const handleCreateTemplate = () => {
    /*  if (newTemplate.name.trim()) {
      setTemplates([newTemplate.value, ...templates])
      setSelectedTemplate(newTemplate.name)
      setShowModal(false)
      setNewTemplate({ name: "", schema: "payment-schema", format: "PDF" })
    } */
  }

  // Field handling functions
  const handleFieldSelect = (fieldName: any) => {
    setSelectedField(fieldName)
    // Reset the fixed value input when selecting a different field
    const field = fields.find((f: any) => f.name === fieldName)
    //setFixedValue(field?.value || "")
    // Reset add modes when changing fields
    setIsAddingTransform(false)
    setIsAddingExtract(false)
  }

  const handleSetFixedValue = () => {
    if (selectedField) {
      // Update the templateInfo state with the new fixed value
      setTemplateInfo((prevState: any) => {
        const updatedFields = prevState.fields.map((field: any) => {
          if (field.fieldName === selectedField) {
            return {
              ...field,
              fixedValue: fixedValue,
            }
          }
          return field
        })

        // Create a new state object with the updated fields
        const updatedState = {
          ...prevState,
          fields: updatedFields,
        }

        // Immediately dispatch the update to save changes
        dispatch(updateTemplate(updatedState))
          .unwrap()
          .then((response: any) => {
            if (response && response.status === 200) {
              // Show success message
              toast.success(`Fixed value for ${selectedField} updated to: ${fixedValue}`)
              dispatch(getTemplateInfobyID(selectedTemplate))
              .unwrap()
              .then((response: any) => {
             
                const allFields = response?.data?.fields || []
                setTemplateInfo(response?.data)
                setFields(allFields)
               })
            } else {
              toast.error(`Failed to update fixed value`)
            }
          })
          .catch((error: any) => {
            console.error("Error updating fixed value:", error)
            toast.error(`Error updating fixed value: ${error.message || "Unknown error"}`)
          })

        return updatedState
      })

      // Update the selectedFieldExtract with the new fixed value
      if (selectedFieldExtract) {
        setSelectedFieldExtract({
          ...selectedFieldExtract,
          fixedValue: fixedValue,
        })
      }

      // Force refresh the textarea if in editJSON tab
      if (fieldConfigTab === "editJSON") {
        setTimeout(() => {
          const textareaElement = document.querySelector("textarea.font-monospace") as HTMLTextAreaElement
          if (textareaElement && selectedFieldExtract) {
            const updatedJson = {
              ...selectedFieldExtract,
              fixedValue: fixedValue,
            }
            textareaElement.value = JSON.stringify(updatedJson, null, 2)
          }
        }, 50)
      }
      
    }
  }

  // Handle file upload for test tab
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0]
      setTestFile(file)
      // In a real application, you would process the file here
      // For now, we'll just set a dummy record count
      // setTestRecords(5)
      //  setTestResults([])
    }
  }

  // Create a ref map to store refs for each input field
  const inputRefs = useRef<{ [key: string]: React.RefObject<HTMLInputElement> }>({})

  // Function to get or create a ref for an input
  const getInputRef = useCallback((id: string) => {
    if (!inputRefs.current[id]) {
      inputRefs.current[id] = React.createRef<HTMLInputElement>()
    }
    return inputRefs.current[id]
  }, [])

  // Replace the operand1 column in the Filtercolumns array with this updated version
  const Filtercolumns =  [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
        width: 80,
        maxWidth: 100,
      },
      {
        accessor: "operand1",
        Header: "Operand 1",
        minWidth: 100,
        width: 150,
        maxWidth: 200,
        Cell: ({ row }: any) => {
          const inputId = `${row.original.id}-operand1`
          const inputRef = getInputRef(inputId)
          const isNewRow = row.original.isNew
          const value = row.original.operand1

          // Use useEffect to focus the input when needed
          useEffect(() => {
            if ((row.original.isNew && inputRef.current) || (focusedInputId === inputId && inputRef.current)) {
              inputRef.current?.focus()
            }
          }, [row.original.isNew, focusedInputId, inputRef, inputId
            
          ])

          // If it's a new row, show the dropdown, otherwise just show the value
          if (isNewRow) {
            return (
              <div style={{ position: "relative", zIndex: isNewRow ? 1000 : 1 }}>
                <Select
                  id={inputId}
                  value={extractorOptions.find((option) => option.value === value)}
                  options={extractorOptions}
                  onChange={(selected) => {
                    handleUpdateFilter(row.original.id, "operand1", selected?.value || "")
                  }}
                  onFocus={() => setFocusedInputId(inputId)}
                  placeholder="Select Extractor"
                  isClearable
                  isSearchable
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "31px",
                      height: "31px",
                      boxShadow: "none",
                      minWidth: "200px",
                    }),
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "31px",
                      padding: "0 6px",
                    }),
                    input: (provided) => ({
                      ...provided,
                      margin: "0px",
                    }),
                    indicatorsContainer: (provided) => ({
                      ...provided,
                      height: "31px",
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                      width: "300px",
                      maxWidth: "400px",
                    }),
                    option: (provided) => ({
                      ...provided,
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      padding: "8px 12px",
                    }),
                  }}
                />
              </div>
            )
          } else if (value && value.trim() !== "") {
            // Only show non-empty values with nice styling
            return (
              <div
                className="px-2 py-1"
                style={{
                  lineHeight: "31px",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  minWidth: "150px",
                  color: "#495057",
                  backgroundColor: "#f8f9fa",
                  border: "1px solidrgb(88, 103, 117)7, 113)",
                  borderRadius: "4px",
                  fontWeight: "500",
                }}
                title={value}
              >
                {value}
              </div>
            )
          } else {
            // Return empty div for empty values
            return <div className="text-muted">-</div>
          }
        },
      },
      {
        accessor: "parameter",
        Header: "Parameter",
        minWidth: 100,
        width: 150,
        maxWidth: 200,
        Cell: ({ row }: any) => {
          const inputId = `${row.original.id}-parameter`
          const inputRef = getInputRef(inputId)
          const isNewRow = row.original.isNew
          const value = row.original.parameter

          // Use useEffect to focus the input when needed
          useEffect(() => {
            if ((isNewRow && inputRef.current) || (focusedInputId === inputId && inputRef.current)) {
              inputRef.current?.focus()
            }
          }, [isNewRow, focusedInputId, inputRef, inputId])

          if (isNewRow) {
            // Editable input for new rows
            return (
              <Form.Control
                ref={inputRef}
                size="sm"
                type="text"
                value={value || ""}
                onChange={(e) => {
                  handleUpdateFilter(row.original.id, "parameter", e.target.value)
                }}
                onFocus={() => setFocusedInputId(inputId)}
              />
            )
          } else if (value && value.trim() !== "") {
            // Only show non-empty values with nice styling
            return (
              <div
                className="px-2 py-1"
                style={{
                  lineHeight: "31px",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  minWidth: "50px",
                  color: "#495057",
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  fontWeight: "500",
                }}
                title={value}
              >
                {value}
              </div>
            )
          } else {
            // Return empty div for empty values
            return <div className="text-muted">-</div>
          }
        },
      },
      {
        accessor: "operator",
        Header: "Operator",
        minWidth: 100,
        width: 50,
        maxWidth: 200,
        Cell: ({ row }: any) => {
          const inputId = `${row.original.id}-operator`
          const inputRef = getInputRef(inputId)
          const isNewRow = row.original.isNew
          const value = row.original.operator

          // Use useEffect to focus the input when needed
          useEffect(() => {
            if ((isNewRow && inputRef.current) || (focusedInputId === inputId && inputRef.current)) {
              inputRef.current?.focus()
            }
          }, [isNewRow, focusedInputId, inputRef, inputId])

          if (isNewRow) {
            // Editable input for new rows
            return (
              <Select
                id={inputId}
                value={filteroperations.find((option) => option.value === value)}
                options={filteroperations}
                onChange={(selected) => {
                  handleUpdateFilter(row.original.id, "operator", selected?.value || "")
                }}
                onFocus={() => setFocusedInputId(inputId)}
                placeholder="Select Operator"
                isClearable
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  control: (provided) => ({
                    ...provided,
                    minHeight: "31px",
                    height: "31px",
                    boxShadow: "none",
                    minWidth: "150px",
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    height: "31px",
                    padding: "0 6px",
                  }),
                  input: (provided) => ({
                    ...provided,
                    margin: "0px",
                  }),
                  indicatorsContainer: (provided) => ({
                    ...provided,
                    height: "31px",
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    width: "200px",
                  }),
                }}
              />
            )
          } else if (value && value.trim() !== "") {
            // Only show non-empty values with nice styling
            return (
              <div
                className="px-2 py-1"
                style={{
                  lineHeight: "31px",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  minWidth: "200px",
                  color: "#495057",
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  fontWeight: "500",
                }}
                title={value}
              >
                {value}
              </div>
            )
          } else {
            // Return empty div for empty values
            return <div className="text-muted">-</div>
          }
        },
      },
      {
        accessor: "operand2",
        Header: "Operand 2",
        minWidth: 100,
        width: 150,
        maxWidth: 200,
        Cell: ({ row }: any) => {
          const inputId = `${row.original.id}-operand2`
          const inputRef = getInputRef(inputId)
          const isNewRow = row.original.isNew
          const value = row.original.operand2

          // Use useEffect to focus the input when needed
          useEffect(() => {
            if ((isNewRow && inputRef.current) || (focusedInputId === inputId && inputRef.current)) {
              inputRef.current?.focus()
            }
          }, [isNewRow, focusedInputId, inputRef, inputId])

          if (isNewRow) {
            // Editable input for new rows
            return (
              <Form.Control
                ref={inputRef}
                size="sm"
                type="text"
                value={value || ""}
                onChange={(e) => {
                  handleUpdateFilter(row.original.id, "operand2", e.target.value)
                }}
                onFocus={() => setFocusedInputId(inputId)}
              />
            )
          } else if (value && value.trim() !== "") {
            // Only show non-empty values with nice styling
            return (
              <div
                className="px-2 py-1"
                style={{
                  lineHeight: "31px",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  minWidth: "50px",
                  color: "#495057",
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  fontWeight: "500",
                }}
                title={value}
              >
                {value}
              </div>
            )
          } else {
            // Return empty div for empty values
            return <div className="text-muted">-</div>
          }
        },
      },
      {
        accessor: "actions",
        Header: "Actions",
        minWidth: 80,
        width: 100,
        maxWidth: 120,
        Cell: ({ row }: { row: { index: number; original: any } }) => (
          <Button variant="outline-danger" size="sm" onClick={() => handleDeleteFilter(row.index)}>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        ),
      },
    ]
   

  const testResultColumns = [
    {
      Header: "Record #",
      accessor: "record",
    },
  ]

  const testReadResultColumns = [
    {
      Header: "#",
      accessor: "id",
      width: 80,
      minWidth: 80,
      maxWidth: 100,
    },
    {
      Header: "Page",
      accessor: "pageNumber",
      Cell: ({ value }: any) => `Page: ${value || "N/A"}`,
      width: 150,
      minWidth: 150,
      maxWidth: 200,
    },
    {
      Header: "Line",
      accessor: "lineNumber",
      Cell: ({ value }: any) => `Line: ${value || "N/A"}`,
      width: 150,
      minWidth: 150,
      maxWidth: 200,
    },
    {
      Header: "Text",
      accessor: "text",
      Cell: ({ value, row }: any) =>
        value || (row.original.value && JSON.stringify(row.original.value)) || "N/A",
      minWidth: 400,
      maxWidth: 1000,
      style: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflow: "visible",
      },
    }
    
  ]

  // Update the transformColumns to remove the edit button and adjust widths
  const transformColumns = [
   
    {
      accessor: "step",
      Header: "Step",
      minWidth: 150,
      width: 200,
      maxWidth: 300,
    },
     {
  accessor: "parameter",
  Header: "Parameter",
  minWidth: 200,
  width: 300,
  maxWidth: 400,
  Cell: ({ value }: { value: string }) => value?.replace(/,+\s*$/, '')
},
     {
      accessor: "actions",
      Header: "Actions",
      minWidth: 80,
      width: 100,
      maxWidth: 120,
      Cell: ({ row }: { row: { index: number; original: any } }) => (
        <Button
          className="me-2"
          size="sm"
          variant="outline-danger"
          onClick={() => handleDeleteTransformation(row.index)}
          disabled={isAddingTransform && !row.original.isNew}
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      ),
    },
  ];

  const extractorColumns = [
 
    {
      accessor: "type",
      Header: "Type",
      minWidth: 150,
      width: 200,
      maxWidth: 300,
    },
    {
      accessor: "parameter",
      Header: "Parameter",
      minWidth: 200,
      width: 300,
      maxWidth: 400,
    },
       {
      accessor: "actions",
      Header: "Actions",
      minWidth: 80,
      width: 100,
      maxWidth: 120,
      Cell: () => (
        <Button
          className="me-2"
          size="sm"
          variant="outline-danger"
          onClick={handleDeleteExtractor}
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      ),
    },
  ];
  // inside your component
  const [activeKey, setActiveKey] = useState("info") // default tab
  const dashboardPath = "/templateUpload"

  const sideWidth =
    Object.entries({
      [dashboardPath]: 0,
      "/templateUpload/add": 5,
    }).find(([path, _]) => matchPath(path, location.pathname.toLowerCase()))?.[1] ?? 10

  // Add useEffect to focus on the newly added transformation field
  useEffect(() => {
    if (isAddingTransform) {
      // Find the new transformation that was just added
      const newTransform = transformRules.find((rule) => rule.isNew)
      if (newTransform) {
        // Focus on the operation name field of the new transformation
        const inputId = `${newTransform.id}-step`
        setFocusedInputId(inputId)

        // Use setTimeout to ensure the DOM has been updated
        setTimeout(() => {
          const inputElement = document.getElementById(inputId) || inputRefs.current[inputId]?.current
          if (inputElement) {
            inputElement.focus()
          }
        }, 50)
      }
    }
  }, [isAddingTransform, transformRules, getInputRef])

  // Update the getInputRef function to add id attribute to inputs

  const SPECIAL_CHAR_MAP: { [key: string]: string } = {
    '@@': ',',
    '##': '|',
    // add more if needed
  };
  function mapSpecialChar(input: string): string {
    return SPECIAL_CHAR_MAP[input as keyof typeof SPECIAL_CHAR_MAP] || input;
  }

  // Add this useEffect after transformOperation and transformParameters are defined
  useEffect(() => {
    if (transformOperation) {
      const paramCount = getOperationParameters(transformOperation).length;
      setTransformParameters(Array(paramCount).fill(""));
    }
  }, [transformOperation]);

  useEffect(() => {
    console.log("transformParameters updated:", transformParameters);
  }, [transformParameters]);

  const [isJsonDirty, setIsJsonDirty] = useState(false);
  const [testError, setTestError] = useState(''); // Add this state near other test states

  return (
    <DashboardContainer sideWidth={sideWidth}>
               <UnsavedChangesModal
        show={showUnsavedModal}
        onHide={handleStayOnPage}
        onConfirm={handleLeavePage}
      />

      <div style={{ padding: "20px" }}>
        {/* Top Dropdown for Template Selection */}
        <div style={{ display: "flex", alignItems: "center" }} className="mb-0">
          {/* Dropdown */}
          <Form.Group controlId="blReqIns.deliveryType" className="mb-0" style={{ marginRight: "0.5rem" }}>
            <InputGroup>
              <InputGroup.Text className="rounded-pill-l bg-100 fs--1" style={{ fontWeight: 450 }}>
                Template
              </InputGroup.Text>

              <Select
                // render the menu into document.body
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                // position it fixed so it's not clipped by any parent
                menuPosition="fixed"
                // bump up the z‑index on both the portal wrapper and the menu itself
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    width: "400px",
                  }),
                  control: (provided) => ({
                    ...provided,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    minHeight: "auto",
                    boxShadow: "none",
                    flex: 1,
                  }),
                  option: (provided) => ({
                    ...provided,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "400px",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "150px",
                  }),
                }}
                value={templateOptions.find((o: any) => o.value === selectedTemplate)}
                options={templateOptions}
                isClearable
                isSearchable
                placeholder="Select Template"
                onChange={(opt) => setSelectedTemplate(opt?.value || "")}
                className="rounded-pill-r text-primary fs--1"
                formatOptionLabel={(data) => <div title={data.label}>{data.label}</div>}
              />
            </InputGroup>
          </Form.Group>

          {/* Add‑new button right next to it */}
          <Button
            variant="primary"
            size="sm"
            className="btn-falcon-primary py-2 px-3" // Adjusted padding
            onClick={() => navigate("/templateUpload/add")}
          >
            <FontAwesomeIcon icon={faPlus} className="me-1 fa-lg" />
          </Button>
        </div>
      </div>

      {/* Stepper Header with lines */}
      {selectedTemplate !== "" && (
          <div
            style={{
              position: "sticky",
              top: "10px",
              zIndex: 1030,
            //  padding: "20px 0 19px",
              // borderBottom: "1px solid rgb(230, 228, 222)",
              //  backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                position: "relative",
                padding: "0 40px",
                gap: "16px", // spacing between steps
              }}
            >
           {stepList.map((step) => {
  const isActive = activeKey === step.key
  return (
    <div
      key={step.key}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px", // spacing between icon and label
        cursor: "pointer",
        zIndex: 1,
        justifyContent: "center",
        padding: "4px 8px", // optional padding
      }}
      onClick={() => setActiveKey(step.key)}
    >
      <div
        style={{
          width: 30,
          height: 30,
          borderRadius: "50%",
          backgroundColor: isActive ? "#007bff" : "#f0f0f0",
          color: isActive ? "#fff" : "#000",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 18,
        }}
      >
        <i className={`bi ${step.icon}`}></i>
      </div>
      <div
        style={{
          fontSize: 14,
          fontWeight: isActive ? "bold" : "normal",
          color: isActive ? "#007bff" : "#000",
          whiteSpace: "nowrap",
        }}
      >
        {step.label}
      </div>
    </div>
  )
})}

            </div>

            <Divider />

            {/* Tab Content */}
            <Tab.Container activeKey={activeKey} onSelect={(k: any) => setActiveKey(k)}>
              <Card className="mb-3 rounded-0 border-0 shadow-none bg-transparent">
                {/* Tab headers */}
                <Card.Header className="p-0 border-bottom-0">{/* Nav tabs moved to stepper above */}</Card.Header>

                {/* Tab panes */}
                <Card.Body className="p-3">
                  {/*     <h5 className="mb-4 text-primary">Template: {selectedTemplate}</h5> */}

                  <Tab.Content>
                    {/* INFO */}
                    <Tab.Pane eventKey="info">
                      <Row className="mb-1">
                        <Col md={2} className="fw-bold">
                          Template Name:
                        </Col>
                        <Col md={8} className="d-flex align-items-center">
                          {isEditingTemplateName ? (
                            <InputGroup>
                              <Form.Control
                                type="text"
                                placeholder="Enter template name"
                                value={editedTemplateName}
                                onChange={handleTemplateNameChange}
                              />
                              <Button
                                className="me-2"
                                size="sm"
                                variant="outline-success"
                                onClick={toggleTemplateNameEdit}
                              >
                                <i className="bi bi-check"></i>
                              </Button>
                              <Button
                                className="me-2"
                                size="sm"
                                variant="outline-secondary"
                                onClick={cancelTemplateNameEdit}
                              >
                                <i className="bi bi-x"></i>
                              </Button>
                            </InputGroup>
                          ) : (
                            <>
                              {templateInfo?.templateName}
                              <FontAwesomeIcon
                                icon={faPencilAlt}
                                className="ms-2 text-secondary cursor-pointer"
                                onClick={toggleTemplateNameEdit}
                              />
                            </>
                          )}
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md={2} className="fw-bold">
                          File Format:
                        </Col>
                        <Col md={8}> {templateInfo?.format}</Col>
                      </Row>
                      <Row className="mb-4">
                        <Col md={2} className="fw-bold">
                          Schema:
                        </Col>
                        <Col md={8}> {templateInfo?.schemaName}</Col>
                      </Row>
                      <Button
                        className="me-2"
                        size="sm"
                        variant="danger"
                        onClick={() => {
                          if (selectedTemplate) {
                            dispatch(templateDelete(selectedTemplate))
                              .unwrap()
                              .then((response: any) => {
                                toast.success("Template deleted successfully")
                                // Clear the selected template and navigate back to the template list
                                setSelectedTemplate("")
                                // Refresh the template list
                                dispatch(getTemplateList())
                                  .unwrap()
                                  .then((response: any) => {
                                    setTemplates(response)
                                  })
                              })
                              .catch((error: any) => {
                                console.error("Error deleting template:", error)
                                toast.error("Error deleting template")
                              })
                          } else {
                            toast.warning("No template selected")
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} className="me-1" />
                        Delete
                      </Button>
                    </Tab.Pane>

                    {/* FIELDS */}
                    <Tab.Pane eventKey="fields">
                      <Row>
                        {/* Field List - Left Side */}
                        <Col md={2}>
                   {/*        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            <div style={{ minHeight: "100%", height: "100%" }}> */}
                              <DataTable
                                columns={fieldColumns}
                                data={fields}
                                gridName="FIELD_LIST"
                                selection={false}
                                searchable={false}
                                pagination={false}
                                autoHeight={true}
                                sortable={false}
                                perPage={10}
                                showColumnFilter={false}
                                showExport={false}
                                uniqueFilterKey="field_list"
                              />
                        {/*     </div>
                          </div> */}
                        </Col>

                        {/* Field Configuration - Right Side */}
                        <Col md={10}>
                          {selectedField && (
                            <Card className="border-0">
                              <Card.Header className="p-3 border-bottom">
                                <h5 className="mb-0">
                                  Field Name: <strong>{selectedField}</strong>
                                </h5>
                                <Nav variant="tabs" className="mt-3">
                                  {["fixedValue", "filter", "extract", "transform", "editJSON", "test"].map((tab) => (
                                    <Nav.Item key={tab}>
                                      <Nav.Link
                                        active={fieldConfigTab === tab}
                                        onClick={() => {
                                          setFieldConfigTab(tab)
                                          // const selected = fields.find((item: any) => item.fieldName === selectedField);
                                          // setFixedValue(selected?.fixedValue || "");
                                        }}
                                        className="text-capitalize"
                                      >
                                        {tab.replace(/([A-Z])/g, " $1").trim()}
                                      </Nav.Link>
                                    </Nav.Item>
                                  ))}
                                </Nav>
                              </Card.Header>

                              <Card.Body>
                                {fieldConfigTab === "fixedValue" && (
                                  <div>
                                    <div className="mb-3">
                                      {fixedValue == "" && (
                                        <p className="text-muted">No Fixed Value is defined for this field.</p>
                                      )}
                                    </div>

                                    <Form>
                                      <Form.Group className="d-flex align-items-center gap-3">
                                        <Form.Label className="mb-0">Set Fixed Value:</Form.Label>
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            value={fixedValue}
                                            onChange={(e) => setFixedValue(e.target.value)}
                                          />
                                          <Button
                                            variant="primary"
                                            className="me-2"
                                            size="sm"
                                            onClick={handleSetFixedValue}
                                          >
                                            <i className="bi bi-check"></i>
                                          </Button>
                                        </InputGroup>
                                      </Form.Group>
                                    </Form>
                                  </div>
                                )}
                                {fieldConfigTab === "filter" && (
                                  <div
                                    ref={tableContainerRef}
                                    style={{
                                      maxHeight: "250px", // Reduced height to ensure buttons are visible
                                      overflowY: "auto",
                                      marginBottom: "20px", // Increased margin to create more space for buttons
                                    }}
                                  >
                                    <DataTable
                                      columns={Filtercolumns}
                                      data={filterRules}
                                      gridName="FILTER"
                                      selection={false}
                                      searchable={false}
                                      pagination={false}
                                      autoHeight={true}
                                      sortable
                                      perPage={50}
                                      showColumnFilter={false}
                                      tableMinHeight={filterRules.length > 0 ? filterRules.length * 50 : 100}
                                      showExport={false}
                                      uniqueFilterKey="filter"
                                    />
                                    {isAddingFilter ? (
                                      <div className="d-flex gap-2 mt-4">
                                        <Button className="me-2" size="sm" variant="primary" onClick={handleSubmitFilter}>
                                          Submit
                                        </Button>
                                        <Button
                                          className="me-2"
                                          size="sm"
                                          variant="secondary"
                                          onClick={handleResetFilter}
                                        >
                                          Reset
                                        </Button>
                                      </div>
                                    ) : (
                                      <Button className="me-2" size="sm" variant="primary" onClick={handleAddFilter}>
                                        Add Filter
                                      </Button>
                                    )}

                                    <Modal
                                      show={showFilterSlider}
                                      onHide={handleCancelFilterForm}
                                      centered
                                      backdrop="static"
                                      size="lg"
                                    >
                                      <Modal.Header closeButton>
                                        <Modal.Title>Add Filter</Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        <Form>
                                          <div className="mb-4">
                                            <h6 className="fw-bold">Operand 1</h6>
                                            <Row>
                                              <Col md={12}>
                                                <Form.Group>
                                                  <Form.Label>Fixed Value</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    name="fixedValue1"
                                                    value={newFilter.fixedValue1}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter value"
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                          </div>
                                          <div className="mb-4">
                                            <Row className="mb-3">
                                              <Col md={12}>
                                                <Form.Group>
                                                  <Form.Label>Extractor Name</Form.Label>
                                                  <Select
                                                    value={extractorOptions.find(
                                                      (option) => option.value === newFilter.operand1,
                                                    )}
                                                    options={extractorOptions}
                                                    onChange={(selected) =>
                                                      setNewFilter({ ...newFilter, operand1: selected?.value || "" })
                                                    }
                                                    placeholder="Select Extractor"
                                                    isClearable
                                                    isSearchable
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    styles={{
                                                      menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                      }),
                                                      control: (provided) => ({
                                                        ...provided,
                                                        boxShadow: "none",
                                                      }),
                                                      menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                        width: "100%",
                                                      }),
                                                      option: (provided) => ({
                                                        ...provided,
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        padding: "8px 12px",
                                                      }),
                                                    }}
                                                  />
                                                </Form.Group>
                                                {/* Dynamic parameter fields for operand1 extractor */}
                                                {newFilter.operand1 && getExtractorParameters(newFilter.operand1).map((param: any, index: number) => (
                                                  <Form.Group key={index} controlId={`operand1-param-${index}`} className="mt-3">
                                                    <Form.Label>{param.label}</Form.Label>
                                                    <Form.Control
                                                      type={param.label.toLowerCase().includes('index') ? 'number' : 'text'}
                                                      name="index"
                                                      placeholder={`Enter ${param.label.toLowerCase()}`}
                                                      min={param.label.toLowerCase().includes('index') ? "1" : undefined}
                                                      value={newFilter.index || ""}
                                                      onChange={handleInputChange}
                                                    />
                                                  </Form.Group>
                                                ))}
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col md={12}>
                                                <Form.Group>
                                                  <Form.Label>Parameter</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    name="parameter"
                                                    value={newFilter.parameter}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter parameter"
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                          </div>

                                          <div className="mb-4">
                                            <h6 className="fw-bold">Filter Condition</h6>
                                            <Row>
                                              <Col md={12}>
                                                <Form.Group>
                                                  <Select
                                                    value={filteroperations.find(
                                                      (option) => option.value === newFilter.operator,
                                                    )}
                                                    options={filteroperations}
                                                    onChange={(selected) =>
                                                      setNewFilter({ ...newFilter, operator: selected?.value || "" })
                                                    }
                                                    placeholder="Select Operator"
                                                    isClearable
                                                    isSearchable
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    styles={{
                                                      menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                      }),
                                                      control: (provided) => ({
                                                        ...provided,
                                                        boxShadow: "none",
                                                      }),
                                                      menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                        width: "100%",
                                                      }),
                                                      option: (provided) => ({
                                                        ...provided,
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                        padding: "8px 12px",
                                                      }),
                                                    }}
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                          </div>

                                          {/* Update the Operand 2 section in the Modal with this updated version */}
                                          <div className="mb-4">
                                            <h6 className="fw-bold">Operand 2</h6>
                                            {newFilter.operator === "is-a" ? (
                                              <Row>
                                                <Col md={12}>
                                                  <Form.Group>
                                                    <Form.Label>Is A Value</Form.Label>
                                                    <Select
                                                      value={dataTypeOptions.find(
                                                        (option) => option.value === newFilter.dataType,
                                                      )}
                                                      options={dataTypeOptions}
                                                      onChange={(selected) =>
                                                        setNewFilter({ ...newFilter, dataType: selected?.value || "" })
                                                      }
                                                      placeholder="Select Data Type"
                                                      isClearable
                                                      isSearchable
                                                      menuPortalTarget={document.body}
                                                      menuPosition="fixed"
                                                      styles={{
                                                        menuPortal: (base) => ({
                                                          ...base,
                                                          zIndex: 9999,
                                                        }),
                                                        control: (provided) => ({
                                                          ...provided,
                                                          boxShadow: "none",
                                                        }),
                                                        menu: (base) => ({
                                                          ...base,
                                                          zIndex: 9999,
                                                          width: "100%",
                                                        }),
                                                        option: (provided) => ({
                                                          ...provided,
                                                          whiteSpace: "normal",
                                                          wordBreak: "break-word",
                                                          padding: "8px 12px",
                                                        }),
                                                      }}
                                                    />
                                                    {newFilter.dataType && (
                                                      <small className="text-muted d-block mt-1">
                                                        {dataTypeOptions.find(
                                                          (option) => option.value === newFilter.dataType,
                                                        )?.description || ""}
                                                      </small>
                                                    )}
                                                  </Form.Group>
                                                </Col>
                                              </Row>
                                            ) : ( // Default case: show Extractor/Parameter or Fixed Value
                                              <>
                                                {/* Extractor Name for Operand 2 */}
                                                <Row className="mb-3">
                                                  <Col md={12}>
                                                    <Form.Group>
                                                      <Form.Label>Extractor Name</Form.Label>
                                                      <Select
                                                        value={extractorOptions.find(
                                                          (option) => option.value === newFilter.operand2Extractor,
                                                        )}
                                                        options={extractorOptions}
                                                        onChange={(selected) =>
                                                          setNewFilter({ ...newFilter, operand2Extractor: selected?.value || "" })
                                                        }
                                                        placeholder="Select Extractor"
                                                        isClearable
                                                        isSearchable
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                        styles={{
                                                          menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                          }),
                                                          control: (provided) => ({
                                                            ...provided,
                                                            boxShadow: "none",
                                                          }),
                                                          menu: (base) => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                            width: "100%",
                                                          }),
                                                          option: (provided) => ({
                                                            ...provided,
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word",
                                                            padding: "8px 12px",
                                                          }),
                                                        }}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                </Row>
                                                {/* Dynamic parameter fields for operand2 extractor */}
                                                {newFilter.operand2Extractor && getExtractorParameters(newFilter.operand2Extractor).map((param: any, index: number) => (
                                                  <Row key={index} className="mb-3">
                                                    <Col md={12}>
                                                      <Form.Group>
                                                        <Form.Label>{param.label}</Form.Label>
                                                        <Form.Control
                                                          type={param.label.toLowerCase().includes('index') ? 'number' : 'text'}
                                                          name="operand2Index"
                                                          value={newFilter.operand2Index || ""}
                                                          onChange={handleInputChange}
                                                          placeholder={`Enter ${param.label.toLowerCase()}`}
                                                          min={param.label.toLowerCase().includes('index') ? "1" : undefined}
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                  </Row>
                                                ))}

                                                {/* Fixed Value Input for Operand 2 - Show if no extractor is selected */}
                                                {!newFilter.operand2Extractor && ( // Only show if no extractor is selected
                                                  <Row>
                                                    <Col md={12}>
                                                      <Form.Group>
                                                        <Form.Label>Fixed Value</Form.Label>
                                                        <Form.Control
                                                          type="text"
                                                          name="operand2Value"
                                                          value={newFilter.operand2Value}
                                                          onChange={handleInputChange}
                                                          placeholder="Enter value"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                  </Row>
                                                )}
                                              </>
                                            )}
                                          </div>
                                        </Form>
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <Button
                                          className="me-2"
                                          size="sm"
                                          variant="secondary"
                                          onClick={handleCancelFilterForm}
                                        >
                                          Cancel
                                        </Button>
                                        <Button
                                          className="me-2"
                                          size="sm"
                                          variant="primary"
                                          onClick={handleSubmitFilterForm}
                                          disabled={!newFilter.operand1 || !newFilter.operator}
                                        >
                                          Submit
                                        </Button>
                                      </Modal.Footer>
                                    </Modal>
                                  </div>
                                )}
                                {fieldConfigTab === "extract" && (
                                  <div>
                                    <DataTable
                                      columns={extractorColumns}
                                      data={extractorRules}
                                      gridName="EXTRACT"
                                      selection={false}
                                      searchable={false}
                                      pagination={false}
                                      autoHeight={true}
                                      sortable
                                      perPage={10}
                                      showColumnFilter={false}
                                      showExport={false}
                                      uniqueFilterKey="extract"
                                    />

                                    {/* Add Extractor Button */}
                                    {!isAddingExtract && (
                                      <Button className="me-2" size="sm" variant="primary" onClick={handleAddExtractor}>
                                        Add Extractor
                                      </Button>
                                    )}
                                  </div>
                                )}
                                {fieldConfigTab === "transform" && (
                                  <div
                                    ref={tableContainerRef} // reuse or create a new one if needed
                                    style={{
                                      maxHeight: "250px", 
                                      overflowY: "auto",
                                      marginBottom: "20px", 
                                    }} 
                                  >
                                    <DataTable
                                      columns={transformColumns}
                                      data={transformRules}
                                      gridName="TRANSFORM"
                                      selection={false}
                                      searchable={false}
                                      pagination={false}
                                      autoHeight={true}
                                      sortable
                                      perPage={10}
                                      showColumnFilter={false}
                                      showExport={false}
                                      uniqueFilterKey="transform"
                                    />

                                    {!isAddingTransform && (
                                      <Button
                                        className="me-2"
                                        size="sm"
                                        variant="primary"
                                        onClick={handleAddTransformation}
                                      >
                                        Add Transformation
                                      </Button>
                                    )}
                                  </div>
                                )}

                                {/* Edit JSON Tab */}
                                {fieldConfigTab === "editJSON" && (
        <Modal show onHide={() =>   setFieldConfigTab("fixedValue")} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit JSON</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <textarea
  className="font-monospace"
  style={{
    width: "100%",
    height: "400px",
    resize: "none",

    color: "#1c1c1c",                     // Dark text
    border: "none",                       // No default border
    borderRadius: "6px",                  // Slight rounding
    padding: "12px 16px",                 // Comfortable padding
    fontSize: "14px",
    lineHeight: "1.6",
    fontFamily: "'Fira Code', 'Consolas', 'Courier New', monospace",
    overflow: "auto",
    
    outline: "none",                      // No blue outline on focus
  }}
  value={jsonString || JSON.stringify(selectedFieldExtract, null, 2)}
  onChange={(e) => {
    const input = e.target.value
    setJsonString(input)
    setIsJsonDirty(true);
    try {
      JSON.parse(input) // Just validating here, actual parsing in save
      if (jsonError) setJsonError(null)
    } catch (err) {
      setJsonError("Invalid JSON")
    }
  }}
    spellCheck="false"
  />

{jsonError && <div className="text-danger mt-2">{jsonError}</div>}
        {/* Pagination & Save Controls */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <Button variant="primary" onClick={handleSaveEditedJson} disabled={!!jsonError}>
            Save
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )}


                                {fieldConfigTab === "test" && (
                                  <div className="mb-2 w-100">
                                    <div className="w-100">
                                      <Form.Group
                                        controlId="testFileUpload"
                                        className="mb-1 d-flex align-items-center gap-2"
                                      >
                                        <div className="col-lg-6 mb-0">
                                          <Form.Group controlId="tableComponent.input5">
                                            <input type="file" accept=".pdf, .eml" ref={fileInputRefTest} onChange={handleFileChangeTestByField} />
                                          </Form.Group>
                                        </div>
                                      </Form.Group>
                                      <strong>Total Records: </strong> {testRecordsField}
                                      <div
                                        style={{
                                          height: "170px",
                                          overflowY: "auto",
                                          overflowX: "auto",
                                          border: "1px solid #dee2e6",
                                          borderRadius: "8px",
                                          padding: "16px",
                                          backgroundColor: "#f8f9fa",
                                          fontFamily: "monospace",
                                          fontSize: "14px",
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "10px",
                                        }}
                                      >
                                        {paginatedTestResults?.length > 0 ? (
                                          paginatedTestResults.map((item: any, index: any) => (
                                            <span
                                              key={index}
                                              style={{
                                                backgroundColor: "#e9ecef",
                                                padding: "6px 10px",
                                                borderRadius: "6px",
                                                boxShadow: "inset 0 1px 2px rgba(0,0,0,0.1)",
                                                minWidth: "200px",
                                                textAlign: "center",
                                              }}
                                            >
                                              {item}
                                            </span>
                                          ))
                                        ) : (
                                          <p className="text-muted text-center">No data available</p>
                                        )}
                                      </div>
                                      {/* Pagination Controls */}
                                      <div className="d-flex justify-content-start align-items-center mt-3">
  {/* Previous Button */}
  <Button
    size="sm"
    variant="falcon-secondary"
    className="me-2"
    disabled={testPage === 0}
    onClick={() => setTestPage((prev) => Math.max(prev - 1, 0))}
  >
    <FontAwesomeIcon icon={faChevronLeft} className="me-1" />
    <span>Previous</span>
  </Button>

  {/* Page Info */}
  <div className="text-muted me-2" style={{ fontSize: "0.875rem" }}>
    Page {testPage + 1} of {testTotalPages}
  </div>

  {/* Next Button */}
  <Button
    size="sm"
    variant="falcon-secondary"
    disabled={testPage === testTotalPages - 1}
    onClick={() => setTestPage((prev) => Math.min(prev + 1, testTotalPages - 1))}
  >
    <span>Next</span>
    <FontAwesomeIcon icon={faChevronRight} className="ms-1" />
  </Button>
</div>

                                    </div>
                                  </div>
                                )}
                              </Card.Body>
                            </Card>
                          )}
                        </Col>
                      </Row>
                    </Tab.Pane>

                    <Tab.Pane eventKey="identification">
                      <div className="mb-4">
                        <h5 className="mb-4">{templateInfo?.templateName}</h5>

                        {/* Email Field */}
                        <Row className="mb-4">
                          <Col md={2} className="fw-bold">
                            User Emails:
                          </Col>
                          <Col md={8} className="d-flex align-items-center">
                            {isEditingEmail ? (
                              <>
                                <Form.Control type="email" value={email} onChange={handleEmailChange} className="me-2" />
                                <Button className="me-2" variant="outline-success" size="sm" onClick={toggleEmailEdit}>
                                  <i className="bi bi-check"></i>
                                </Button>
                                <Button
                                className="me-2"
                                size="sm"
                                variant="outline-secondary"
                                onClick={cancelEmailEdit}
                              >
                                <i className="bi bi-x"></i>
                              </Button>
                              </>
                            ) : (
                              <>
                                {email}
                                <FontAwesomeIcon
                                  icon={faPencilAlt}
                                  className="ms-2 text-secondary cursor-pointer"
                                  onClick={toggleEmailEdit}
                                  title="Edit Email"
                                />
                              </>
                            )}
                          </Col>
                        </Row>

                        <hr className="my-4" />

                        {/* Identifier Field */}
                        <Row className="mb-4">
                          <Col md={2} className="fw-bold">
                            Identifiers:
                          </Col>
                          <Col md={8} className="d-flex align-items-center">
                            {isEditingIdentifier ? (
                              <>
                                <Form.Control
                                  type="text"
                                  value={identifier}
                                  onChange={handleIdentifierChange}
                                  className="me-2"
                                />
                                <Button
                                  className="me-2"
                                  size="sm"
                                  variant="outline-success"
                                  onClick={toggleIdentifierEdit}
                                >
                                  <i className="bi bi-check"></i>
                                </Button>
                                <Button
                                className="me-2"
                                size="sm"
                                variant="outline-secondary"
                                onClick={cancelIdentifierEdit}
                              >
                                <i className="bi bi-x"></i>
                              </Button>
                              </>
                            ) : (
                              <>
                                {identifier}
                                <FontAwesomeIcon
                                  icon={faPencilAlt}
                                  className="ms-2 text-secondary cursor-pointer"
                                  onClick={toggleIdentifierEdit}
                                  title="Edit Identifier"
                                />
                                
                              </>
                            )}
                          </Col>
                        </Row>

                        <hr className="my-4" />

                        {/* Response To Field */}
                        <Row className="mb-4">
                          <Col md={2} className="fw-bold">
                            Bulk Response To:
                          </Col>
                          <Col md={5} className="d-flex align-items-center">
                            {isEditingResponseTo ? (
                              <>
                                <Form.Control 
                                  type="text" 
                                  value={responseTo} 
                                  onChange={handleResponseToChange} 
                                  className="me-2" 
                                />
                                <Button className="me-2" variant="outline-success" size="sm" onClick={toggleResponseToEdit}>
                                  <i className="bi bi-check"></i>
                                </Button>
                                <Button
                                  className="me-2"
                                  size="sm"
                                  variant="outline-secondary"
                                  onClick={cancelResponseToEdit}
                                >
                                  <i className="bi bi-x"></i>
                                </Button>
                              </>
                            ) : (
                              <>
                                {responseTo || ""}
                                <FontAwesomeIcon
                                  icon={faPencilAlt}
                                  className="ms-2 text-secondary cursor-pointer"
                                  onClick={toggleResponseToEdit}
                                  title="Edit Response To"
                                />
                              </>
                            )}
                          </Col>
                        </Row>

                        <hr className="my-4" />

                        {/* File Upload */}
                        <Row className="mb-4">
                          <Col md={2} className="fw-bold">
                            Validate Identifiers:
                          </Col>
                          <Col md={8}>
                            <Form.Group controlId="testFileUpload" className="d-flex align-items-center gap-2">
                              <Form.Control type="file" accept=".pdf, .eml"  ref={fileInputIdentifier} onChange={handleValidateIdentifier} />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="read" className="w-100">
                      <div className="mb-0 w-100">
                        <Form.Group controlId="testFileUpload" className="mb-0 d-flex align-items-center gap-2">
                      
                            <Form.Group controlId="testFileUpload" className="mb-1 d-flex align-items-center gap-2">
                              
                                <Form.Group controlId="tableComponent.input5">
                                  <input type="file" accept=".pdf, .eml"  ref={fileInputRef} onChange={handleRead} />
                                </Form.Group>
                     
                            </Form.Group>
                       
                        </Form.Group>
                        {testReadResults && Array.isArray(testReadResults) && testReadResults.length > 0 ? (
                    /*      <div
                            className="read-results-container"
                            style={{ maxHeight: "500px", overflowY: "auto", overflowX: "auto" }}
                          > */
                            <DashboardContainer
                            sideWidth={sideWidth}
                            innerOffset={10}
                          >
                            <DataTable
                              columns={testReadResultColumns}
                              data={testReadResults}
                              gridName="READ_RESULTS"
                              selection={false}
                              searchable={false}
                              localFilter={true}
                              showColumnFilter={false}
                              pagination={true}
                              autoHeight={true}
                              tableMinHeight={100}
                              sortable={true}
                              perPage={8}
                          
                              showExport={false}
                              uniqueFilterKey="read_results"
                  
                          
                            />
                            </DashboardContainer>
                        /*  </div> */
                        ) : (
                          <p className="text-muted text-center mt-5">
                            {testFile ? "Processing file..." : "Upload a file to see results"}
                          </p>
                        )}

                      </div>
                    </Tab.Pane>

                    {/* JSON */}
                    <Tab.Pane eventKey="json">
                      {/* Scrollable JSON container */}

                      {/* Upload button */}
                      {/*  <Form.Group controlId="testFileUpload" className="mb-1 d-flex align-items-center gap-2">
                            <div className="col-lg-6 mb-3">
                              <Form.Group controlId="tableComponent.input5">
                                <input type="file" accept=".pdf" onChange={handleFileChangeTest} />
                              </Form.Group>
                            </div>
                          </Form.Group> */}

                      {/* Space reduced between upload button and textarea */}
                      <div
                      /*   style={{
                              fontFamily: "monospace",
                              fontSize: "14px",
                              whiteSpace: "pre-wrap",
                              height: "400px",
                              overflow: "auto",
                              border: "1px solid #dee2e6",
                              marginTop: "0", // Reducing margin between the upload button and this div
                              paddingTop: "0", // Remove top padding
                            }} */
                      >
                        <Form.Control
                          as="textarea"
                          rows={23}
                          className="font-monospace"
                          value={templateInfo ? JSON.stringify(templateInfo, null, 2) : ""}
                          onChange={(e) => {
                            // Add an onChange handler if you want to make the textarea editable
                            try {
                              const parsed = JSON.parse(e.target.value)
                              // Optional: update state if you want to make it editable
                              // setEditedJsonText(e.target.value);
                            } catch (error) {
                              // Handle invalid JSON if needed
                            }
                          }}
                        />
                      </div>
                    </Tab.Pane>

                    {/* TEST */}
                    <Tab.Pane eventKey="test">
                      <div className="mb-2 w-100">
                        <div className="w-100">
                          <Form.Group controlId="testFileUpload" className="mb-1 d-flex align-items-center gap-2">
                            <div className="col-lg-6 mb-1">
                              <Form.Group controlId="tableComponent.input5">
                                <input type="file" accept=".pdf, .eml" ref={fileInputRefMain} onChange={handleFileChangeTest} />
                              </Form.Group>
                            </div>
                          </Form.Group>
                          <strong>Total Records: </strong> {testRecords}
                          <div
                            style={{
                              position: "relative",
                              height: "calc(100vh - 280px)",
                              maxHeight: "700px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              overflowY: "auto",
                              overflowX: "auto",
                              backgroundColor: "white",
                            }}
                          >
                            <pre
                              style={{
                                margin: 0,
                                padding: "16px",
                                fontSize: "14px",
                                fontFamily: "monospace",
                                whiteSpace: "pre-wrap",
                                wordWrap: "break-word",
                              }}
                            >
{testResults ? JSON.stringify(testResults, null, 2) : ""}
                            </pre>
                          </div>
                        </div>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Card.Body>
              </Card>
            </Tab.Container>
          </div>
      )}
      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>New Template</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                <span style={{ cursor: "pointer" }} onClick={() => setShowModal(true)}>
                  <FontAwesomeIcon icon={faPlus} size="lg" />
                </span>
              </Form.Label>
              <Form.Control
                type="text"
                value={newTemplate.name}
                onChange={(e) => setNewTemplate({ ...newTemplate, name: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Schema</Form.Label>
              <Form.Select
                value={newTemplate.schema}
                onChange={(e) => setNewTemplate({ ...newTemplate, schema: e.target.value })}
              >
                <option value="payment-schema">payment-schema</option>
                <option value="invoice-schema">invoice-schema</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>File Format</Form.Label>
              <Form.Select
                value={newTemplate.format}
                onChange={(e) => setNewTemplate({ ...newTemplate, format: e.target.value })}
              >
                <option value="PDF">PDF</option>
                <option value="CSV">CSV</option>
                <option value="XLSX">XLSX</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className="me-2" size="sm" variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button className="me-2" size="sm" variant="primary" onClick={handleCreateTemplate}>
            Create
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Add this JSX code right before the closing </DashboardContainer> tag */}

      <Modal show={showTransformModal} onHide={() => {setShowTransformModal(false);setTransformOperation('')}} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Add Transformation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Operation Name</Form.Label>
              <Select
                value={transformationOperations.find((option) => option.value === transformOperation)}
                options={transformationOperations}
                onChange={(selected) => {
                  setTransformOperation(selected?.value || "");
                  const paramCount = getOperationParameters(selected?.value || "").length;
                  setTransformParameters(Array(paramCount).fill(""));
                }}
                placeholder="Select Operation"
                isClearable
                isSearchable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base: any) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  control: (provided: any) => ({
                    ...provided,
                    boxShadow: "none",
                  }),
                }}
              />
            </Form.Group>

            {/* Dynamic fields based on operation type*/}
            {transformOperation && getOperationParameters(transformOperation).map((param: any, index: number) => (
              <Form.Group key={index} className="mb-3">
                <Form.Label>{param.label}</Form.Label>
                <Form.Control
                  type={param.label.toLowerCase().includes('length') ? 'number' : 'text'}
                  value={transformParameters[index] || ""}
                  onChange={e => {
                    const newParams = [...transformParameters];
                
                    newParams[index] = e.target.value;
                    setTransformParameters(newParams);
                        console.log("transform",transformParameters)
                  }}
                  placeholder={`Enter ${param.label.toLowerCase()}`}
                />
              </Form.Group>
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className="me-2" size="sm" variant="secondary" onClick={() => { setShowTransformModal(false); setTransformParameters([]); }}>
            Cancel
       
          </Button>
          <Button
            className="me-2"
            size="sm"
            variant="primary"
            onClick={handleSubmitTransformModal}
            disabled={!transformOperation}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <div></div>
      <ExtractorModal
        show={showExtractorModal}
        onHide={() => setShowExtractorModal(false)}
        onSubmit={handleExtractorModalSubmit}
        extractorOptions={extractorOptions}
        pdfParserAppData={pdfParserAppData}
      />
    </DashboardContainer>
  )
}

export default TemplateUploadScreen
